<template>
  <div>
    <invoice-list-desktop-bridge v-if="isDesktopListLayout" />
    <invoice-list-mobile v-else />
    <invoice-doc-view ref="invoiceDocView" @error="serverErrorHandeler" />
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="printDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <printnew
            ref="printRef"
            :header-prop="printHeaders"
            :items-prop="items"
            :dialog="printDialog"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="invoicePrintDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="invoicePrintDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <invoicprint :id-prop="printId" />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="960"
      scrollable
      content-class="acf-wrap"
    >
      <div class="acf acf--compact" :style="proListRootStyle" dir="rtl">
        <header class="acf-head">
          <span class="acf-head__icon">
            <v-icon size="18">mdi-filter-variant</v-icon>
          </span>
          <div class="acf-head__titles">
            <div class="acf-head__title">{{ $t("sellFilterTitle") }}</div>
            <div class="acf-head__sub">
              <template v-if="activeFilterChips.length">
                <span class="acf-badge">{{ faNum(activeFilterChips.length) }}</span>
                {{ $t("accFilterActive") }}
              </template>
              <template v-else>{{ $t("accFilterNone") }}</template>
            </div>
          </div>
          <button type="button" class="acf-x" :title="$t('close')" @click="filter = false">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </header>

        <div class="acf-body">
          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-account-outline</v-icon>
              {{ $t("sellFilterParties") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="account"
                :title="$t('customer')"
                type="person"
                :filter="true"
                :multiple="true"
              />
              <status v-model="sellStatus" :hideconfig="true" />
              <autocomplete
                v-model="currencyFilter"
                :title="$t('currency')"
                type="currency"
                :filter="true"
                :multiple="true"
              />
              <tag v-model="tag" />
              <autocomplete
                v-model="category"
                :title="$t('category')"
                type="accountCategory"
                :filter="true"
                :multiple="true"
              />
              <v-select
                v-model="payedStatus"
                :label="$t('payed-status')"
                :items="payedStatuses"
                dense
                outlined
                clearable
                hide-details
                item-value="value"
                item-text="label"
              />
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-calendar-range</v-icon>
              {{ $t("accFilterDateTime") }}
            </div>
            <div class="acf-grid acf-grid--4">
              <div>
                <v-text-field
                  id="fromId"
                  v-model="fromDate"
                  :label="$t('from') + ' ' + $t('date')"
                  prepend-inner-icon="mdi-calendar-start"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="fromDate"
                  element="fromId"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  auto-submit
                  :color="
                    $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary
                  "
                  @close="setDate"
                />
              </div>
              <div>
                <v-text-field
                  id="toId"
                  v-model="toDate"
                  :label="$t('until') + ' ' + $t('date')"
                  prepend-inner-icon="mdi-calendar-end"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="toDate"
                  element="toId"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  :min="fromDate"
                  auto-submit
                  :color="
                    $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary
                  "
                  @close="setDate"
                />
              </div>
              <div>
                <v-text-field
                  id="fromTime"
                  v-model="fromTime"
                  :label="$t('from-hour')"
                  prepend-inner-icon="mdi-clock-start"
                  outlined
                  dense
                  clearable
                  readonly
                  hide-details
                />
                <date-picker
                  v-model="fromTime"
                  element="fromTime"
                  type="time"
                  :locale="$store.state.date_locale"
                  :format="'HH:mm'"
                  :display-format="'HH'"
                  auto-submit
                  :color="
                    $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary
                  "
                  @close="setDate"
                />
              </div>
              <div>
                <v-text-field
                  id="toTime"
                  v-model="toTime"
                  :label="$t('to-hour')"
                  prepend-inner-icon="mdi-clock-end"
                  outlined
                  dense
                  clearable
                  readonly
                  hide-details
                />
                <date-picker
                  v-model="toTime"
                  element="toTime"
                  type="time"
                  :locale="$store.state.date_locale"
                  :format="'HH:mm'"
                  :display-format="'HH'"
                  auto-submit
                  :color="
                    $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary
                  "
                  @close="setDate"
                />
              </div>
              <div>
                <v-text-field
                  id="fromId1"
                  v-model="fromDueDate"
                  :label="$t('fromDueDate')"
                  prepend-inner-icon="mdi-calendar-clock"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="fromDueDate"
                  element="fromId1"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  auto-submit
                  :color="
                    $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary
                  "
                  @close="setDate"
                />
              </div>
              <div>
                <v-text-field
                  id="toId1"
                  v-model="toDueDate"
                  :label="$t('toDueDate')"
                  prepend-inner-icon="mdi-calendar-clock"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="toDueDate"
                  element="toId1"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  :min="fromDate"
                  auto-submit
                  :color="
                    $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary
                  "
                  @close="setDate"
                />
              </div>
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-pound-box-outline</v-icon>
              {{ $t("accFilterNumberAmount") }}
            </div>
            <div class="acf-grid acf-grid--4">
              <v-text-field
                v-model="fromNumber"
                :label="$t('from') + ' ' + $t('number')"
                outlined
                dense
                clearable
                hide-details
              />
              <v-text-field
                v-model="toNumber"
                :label="$t('until') + ' ' + $t('number')"
                outlined
                dense
                clearable
                hide-details
              />
              <money
                v-model="fromAmount"
                :dense="true"
                :label="$t('from') + ' ' + $t('amount')"
                :outlined="true"
                :solo="false"
                :clearable="true"
                value-when-is-empty=""
                :options="options"
                class="dense"
              />
              <money
                v-model="toAmount"
                :dense="true"
                :label="$t('until') + ' ' + $t('amount')"
                :outlined="true"
                :solo="false"
                :clearable="true"
                value-when-is-empty=""
                :options="options"
                class="dense"
              />
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-office-building-outline</v-icon>
              {{ $t("sellFilterOrg") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="branch"
                title="branch"
                type="branch"
                :filter="true"
                :multiple="true"
              />
              <autocomplete
                v-model="entrepot"
                title="entrepot"
                type="entrepot"
                :filter="true"
                :multiple="true"
              />
              <autocomplete
                v-model="registerar"
                :title="$t('registerar')"
                type="partners"
                :multiple="true"
                :filter="true"
              />
              <v-select
                v-model="lockStatus"
                :label="$t('lockStatusDocuments')"
                :items="lockStatusItems"
                dense
                outlined
                clearable
                hide-details
                item-value="value"
                item-text="text"
              />
              <v-select
                v-model="selectedHeaders"
                :items="headers"
                :label="$t('sellFilterColumns')"
                dense
                outlined
                multiple
                return-object
                hide-details
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="acf-sel">{{ item.text }}</span>
                  <span v-if="index === 1" class="acf-sel acf-sel--more">
                    +{{ faNum(selectedHeaders.length - 1) }}
                  </span>
                </template>
              </v-select>
            </div>
          </section>

          <section v-if="!isMobile && customFieldsPermission" class="acf-sec">
            <div class="acf-sec__head acf-sec__head--spread">
              <span class="acf-sec__head-label">
                <v-icon size="17">mdi-form-textbox</v-icon>
                {{ $t("sellFilterCustom") }}
              </span>
              <button
                type="button"
                class="acf-sec__add"
                :title="$t('clickForAddCustomeField')"
                @click="addInvoiceFilterCustomField"
              >
                <v-icon size="15">mdi-plus</v-icon>
                {{ $t("addCustomeField") }}
              </button>
            </div>
            <invoice-filter-custom-fields
              ref="invoiceFilterCf"
              v-model="customFields"
              :value="customFields"
              type-prop="invoiceCustomFields"
              :multiple="true"
            />
          </section>
        </div>

        <footer class="acf-foot">
          <button type="button" class="acf-btn acf-btn--primary" @click="getItems">
            <v-icon size="16">mdi-filter-check-outline</v-icon>
            {{ $t("accFilterApply") }}
          </button>
          <button
            type="button"
            class="acf-btn acf-btn--ghost"
            :disabled="!activeFilterChips.length"
            @click="resetFilters"
          >
            <v-icon size="16">mdi-filter-remove-outline</v-icon>
            {{ $t("accDocListClearFilters") }}
          </button>
          <span class="acf-spacer" />
          <button type="button" class="acf-btn" @click="filter = false">
            {{ $t("cancel") }}
          </button>
        </footer>
      </div>
    </v-dialog>
    <v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn v-if="selected.length > 0" color="primary" @click="removegroup">
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="uploadDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="uploadDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col class="mt-0 pt-0 pr-7">
          <upload
            type-prop="invoice"
            :get-item="uploadDialog"
            @close="uploadDialog = false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="documentsDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="documentsDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <div align="center" class="px-4">
          <v-btn color="primary" block elevation="0" style="font-size: 16px">
            {{ documentsTitleDialog }}
          </v-btn>
        </div>
        <v-col class="mt-0 pt-0 pr-7">
          <file-picker
            ref="refFilePicker"
            :label="$t('addDocuments')"
            :multiple="false"
            :hide-remove="true"
            type-prop="invoice"
            :val="documents ? documents : null"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    print dialog-->
    <v-dialog
      v-model="groupPrintDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="40%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="groupPrintDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col class="text-right">
            <v-radio-group v-model="printType">
              <v-radio value="officialInvoice">
                <template v-slot:label>
                  <div>{{ $t("officialInvoice") }}</div>
                </template>
              </v-radio>
              <v-radio value="invoice">
                <template v-slot:label>
                  <div>{{ $t("generalInvoice") }}</div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-btn color="primary" :loading="loading" @click="groupPrintInvoice">
            {{ $t("print") }}
          </v-btn>
          <v-spacer />
          <v-btn color="grey" @click="groupPrintDialog = !groupPrintDialog">
            {{ $t("close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--checkAverageDialog-->
    <v-dialog
      v-model="checkAverageDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="600"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center">
          <v-card-text class="pa-0 text-body-1">{{ $t("invoice-list") }}</v-card-text>
          <v-icon size="15" @click="checkAverageDialog = false">mdi-close</v-icon>
        </v-container>
        <v-container class="pa-0 d-flex justify-space-between align-end my-6">
          <div>
            <v-card-text class="pa-0 text-body-2">
              {{ $t("count") }} : {{ selectedCheck ? selectedCheck.length : "" }}
              {{ $t("numbers") }}
            </v-card-text>
            <v-card-text class="pa-0 text-body-2 mt-1">
              {{ $t("sumAmount") }} : {{ checksTotal ? $numberFormat(checksTotal) : 0 }}
              {{ $t("rial") }}
            </v-card-text>
            <v-card-text class="pa-0 text-body-1 mt-1">
              {{ $t("invoice-count") }} :
              {{
                checkAverageDate ? checkAverageDate.split("T")[0].replace(/-/g, "/") : ""
              }}
            </v-card-text>
          </div>
          <div class="d-flex justify-end flex-column">
            <v-btn
              color="primary"
              height="32"
              class="mb-4 mr-12"
              :loading="loading"
              @click="fetchCheckAverageSecond"
            >
              {{ $t("invoice-head-recalculation") }}
            </v-btn>
            <template>
              <v-text-field
                id="selectedDate"
                v-model="selectedDate"
                :label="$t('date')"
                append-icon="mdi-calendar"
                :rules="[(v) => !!v || $t('is-required')]"
                outlined
                dense
                clearable
                :class="{ 'mt-5': isMobile }"
              />
              <date-picker
                v-model="selectedDate"
                element="selectedDate"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :min="$store.state.startDate"
                :max="$store.state.endDate"
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </div>
        </v-container>
        <v-data-table
          :headers="checkAverageHeaders"
          :items="checkAverageItems"
          :items-per-page="-1"
          hide-default-footer
          :height="isMobile || isTablet ? 265 : 265"
          fixed-header
          class="checkAverage"
          style="background-color: #eeeeee"
          :class="{ 'ma-5': isMobile }"
        >
          <template v-slot:item.row="{ item, index }">
            <v-card-text class="pa-0 text-caption">
              {{ index + 1 }}
            </v-card-text>
          </template>
          <template v-slot:item.checkNumber="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{ item.number ? item.number : $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:item.detailsInvoice="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{ item.customer ? item.customer.name : $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:item.dueDate="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{ item.due_date ? item.due_date : $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:item.amount="{ item }">
            <v-card-text v-if="item.price" class="pa-0 text-caption">
              {{ $numberFormat(item.price.price) }} {{ item.currency.name }}
            </v-card-text>
            <v-card-text v-else class="pa-0 text-caption">
              {{ $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:header.edit="{ header }">
            <div @click="openCheckDeleteDialog('all')">
              <my-icon
                :name="'trash-icon'"
                :width="15"
                :height="15"
                :cursor-pointer="true"
              />
            </div>
          </template>
          <template v-slot:item.edit="{ item, index }">
            <div @click="openCheckDeleteDialog('single', item.id)">
              <my-icon
                :name="'trash-icon'"
                :width="15"
                :height="15"
                :cursor-pointer="true"
              />
            </div>
          </template>
        </v-data-table>
        <v-card-text
          v-if="isThereInvoiceWithoutId"
          class="pa-0 text-body-2 mt-1"
          style="color: #ff5252"
        >
          {{ $t("only invoices with due-date can be calculated") }}
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--check delete dialog-->
    <v-dialog
      v-model="checkDeleteDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-card-text class="pa-0 text-body-2">
          {{
            deleteAllCheck
              ? $t("are you sure you want to delete all items?")
              : $t("Are you sure you want to delete this item ?")
          }}
        </v-card-text>
        <v-container class="pa-0 d-flex align-center gap-1 mt-7">
          <v-btn color="error" height="32" @click="deleteCheck">
            {{ $t("yes") }}
          </v-btn>
          <v-btn
            outlined
            height="32"
            color="secondary"
            @click="checkDeleteDialog = false"
          >
            {{ $t("no") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <!--tax payer confirmation-->
    <v-dialog
      v-model="taxPayerConfirmDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="400"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center">
          <v-card-text class="pa-0 text-body-2">
            {{ $t("are you share you want to send these items to taxpayer system ?") }}
          </v-card-text>
          <v-icon size="15" @click="taxPayerConfirmDialog = false">mdi-close</v-icon>
        </v-container>
        <v-container class="pa-0 d-flex align-center gap-1 mt-7">
          <v-btn color="primary" height="32" @click="sendToTaxPayer" :loading="loading">
            {{ $t("yes") }}
          </v-btn>
          <v-btn
            outlined
            height="32"
            color="secondary"
            @click="taxPayerConfirmDialog = false"
          >
            {{ $t("no") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <!--Invoices with errors-->
    <v-dialog
      v-model="invoiceErrorDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="750"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center mb-4">
          <v-card-text class="pa-0 text-body-1">
            {{ $t("invoice errors while submit to taxpayer system") }}
          </v-card-text>
          <v-icon size="15" @click="invoiceErrorDialog = false">mdi-close</v-icon>
        </v-container>
        <v-card-text class="pa-0 text-body-2">
          {{
            $t(
              "the following invoices encountered an error while being sent to the system"
            )
          }}
        </v-card-text>
        <v-data-table
          :headers="invoiceErrorHeaders"
          :items="invoiceErrorItems"
          :items-per-page="-1"
          hide-default-footer
          :height="isMobile || isTablet ? 265 : 265"
          fixed-header
          class="checkAverage errors mt-5"
          :class="{ 'ma-5': isMobile }"
        >
          <template v-slot:item.row="{ item, index }">
            <v-card-text class="pa-0 text-caption">{{ index + 1 }}</v-card-text>
          </template>
          <template v-slot:item.invoiceNumber="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{ item.invoice.number ? "#" + item.invoice.number : $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:item.amount="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{
                item.invoice.price && item.invoice.price.price && item.invoice.currency
                  ? $numberFormat(
                      item.invoice.price.price,
                      item.invoice.currency.decimal
                    ) +
                    " " +
                    item.invoice.currency.symbol
                  : $t("haveNot")
              }}
            </v-card-text>
          </template>
          <template v-slot:item.detailsInvoice="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{
                item.invoice.customer && item.invoice.customer.name
                  ? item.invoice.customer.name
                  : $t("haveNot")
              }}
            </v-card-text>
          </template>
          <template v-slot:item.registerDate="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{ item.invoice.date ? item.invoice.date : $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn text @click="showErrorDetails(item)">
              {{ $t("show-details") }}
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
    <!--Invoice errors with details-->
    <v-dialog
      v-model="invoiceErrorDetailsDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="550"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center mb-4">
          <v-card-text class="pa-0 text-body-1">
            {{
              $t("errors-invoice") +
              (selectedInvoiceItem && selectedInvoiceItem.invoice.number
                ? selectedInvoiceItem.invoice.number + "#"
                : $t("haveNot"))
            }}
          </v-card-text>
          <v-icon size="15" @click="invoiceErrorDetailsDialog = false">mdi-close</v-icon>
        </v-container>
        <v-data-table
          :headers="invoiceErrorDetailsHeaders"
          :items="selectedInvoiceErrors"
          :items-per-page="-1"
          hide-default-footer
          :height="isMobile || isTablet ? 265 : 265"
          fixed-header
          class="checkAverage errors mt-5"
          :class="{ 'ma-5': isMobile }"
        >
          <template v-slot:item.row="{ item, index }">
            <v-card-text class="pa-0 text-caption">{{ index + 1 }}</v-card-text>
          </template>
          <template v-slot:item.systemErrors="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{
                item.code && item.message
                  ? "(" + item.code + ")" + " " + item.message
                  : $t("haveNot")
              }}
            </v-card-text>
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn text @click="editInvoice">
              {{ $t("edit-invoice") }}
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
    <!--taxpayer show status dialog-->
    <v-dialog
      v-model="taxPayerStatusReviewDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="550"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center mb-4">
          <v-card-text class="pa-0 text-body-1">
            {{
              $t("errors-invoice") +
              (taxPayerStatusError ? taxPayerStatusError.head_id + "#" : $t("haveNot"))
            }}
          </v-card-text>
          <v-icon size="15" @click="taxPayerStatusReviewDialog = false">mdi-close</v-icon>
        </v-container>
        <v-data-table
          :headers="taxPayerStatusErrorHeaders"
          :items="taxPayerStatusErrorItems"
          :items-per-page="-1"
          hide-default-footer
          :height="isMobile || isTablet ? 265 : 265"
          fixed-header
          class="checkAverage errors mt-5"
          :class="{ 'ma-5': isMobile }"
        >
          <template v-slot:item.row="{ item, index }">
            <v-card-text class="pa-0 text-caption">{{ index + 1 }}</v-card-text>
          </template>
          <template v-slot:item.systemErrors="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{
                item.code && item.message
                  ? "(" + item.code + ")" + " " + item.message
                  : $t("haveNot")
              }}
            </v-card-text>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
    <!-- alert type dialog -->
    <v-dialog
      v-model="alertDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="450"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-end mb-5">
          <v-icon size="15" @click="alertDialog = false">mdi-close</v-icon>
        </v-container>
        <v-container class="pa-0 d-flex justify-center align-center">
          <v-card-text class="pa-0 text-center">
            <span class="text-body-1">{{ alertDialogText }}</span>
            <br /><br />
            <span v-if="!successAlert" class="text-body-2">{{
              $t("taxPayer system is working on this invoice")
            }}</span>
          </v-card-text>
        </v-container>
        <v-container class="pa-0 d-flex justify-center align-center mt-5">
          <v-btn @click="alertDialog = false" color="error" height="32">
            {{ $t("close") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>

    <payed-details-dialog v-model="payedDialog" :item="selectedPayedItem" />

    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : ''"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Task from "../task/task";
import Invoicprint from "./print";
import General from "../../../../Mixins/general";
import Upload from "../../components/general/upload/upload";
import filePicker from "../../components/general/filePicker/index";
import TaxPayerContent from "./taxPayerContent.vue";
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";
import PayedDetailsDialog from "./partial/PayedDetailsDialog.vue";
import InvoiceFilterCustomFields from "./partial/InvoiceFilterCustomFields.vue";
import InvoiceListDesktopBridge from "./layouts/desktop/InvoiceListDesktopBridge.vue";
import InvoiceListMobile from "./layouts/mobile/InvoiceListMobile.vue";
import InvoiceDocView from "./layouts/InvoiceDocView.vue";
import moment from "moment-jalaali";
import {
  applyColumnSettings,
  loadColumnSettings,
} from "@/plugins/columnSettings/columnSettings";
import { reorderPinnedHeaders } from "@/plugins/columnPin/columnPin";
import ProList from "@/Mixins/proList";
import PrintStudio from "@/modules/print/PrintStudio.vue";
import ProListFrame from "@/components/proList/ProListFrame.vue";

export default {
  name: "InvoiceList",
  components: {
    autocomplete: () => import("../../components/general/patial/autocomplete"),
    Tag: () => import("../../components/general/Tag/tag"),
    Status: () => import("../../components/general/Status/status"),
    dialogComponent: () => import("../../components/general/dialog/index"),
    Upload,
    InvoiceFilterCustomFields,
    filePicker,
    TaxPayerContent,
    Invoicprint,
    Task,
    MyIcon,
    PayedDetailsDialog,
    InvoiceListDesktopBridge,
    InvoiceDocView,
    InvoiceListMobile,
    ProListFrame,
    PrintStudio,
  },
  mixins: [General, ProList],
  props: ["input", "refId", "typeProp", "accountProp", "mobileShow"],
  provide() {
    return { invoiceList: this };
  },
  data: () => ({
    selected: [],
    printHeaders: [],
    datatableStore: false,
    summary: null,
    registerar: null,
    removedInvoices: null,
    groupPrintDialog: false,
    invoicePrintDialog: false,
    printDialog: false,
    deletDialog: false,
    uploadDialog: false,
    documentsDialog: false,
    documents: false,
    documentsTitleDialog: "",
    printType: "invoice",
    dialogData: null,
    entrepot: null,
    category: null,
    account: null,
    currencyFilter: null,
    fromAmount: null,
    toAmount: null,
    fromNumber: null,
    toNumber: null,
    fromDate: null,
    toDate: null,
    fromDueDate: null,
    toDueDate: null,
    printId: null,
    showSelect: true,
    filter: false,
    productStatus: null,
    productStatusItems: null,
    model: null,
    from: 1,
    customFields: null,
    taskDialog: null,
    tag: null,
    temp: null,
    deleteItem: null,
    sellStatus: null,
    items: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 0,
    snakbar: false,
    typeForm: null,
    taskId: null,
    snakbarText: null,
    loading: true,
    options: {
      itemsPerPage: 5,
    },
    headers: null,
    type: null,
    search: null,
    selectedHeaders: [],
    selectedHeadersTemp: [],
    headersMap: null,
    pageCount: 1,
    page: 1,
    excelItems: [],
    selectedCheck: [],
    today: null,
    checkAverageDialog: false,
    selectedDate: null,
    today: null,
    checkAverageItems: null,
    checkDeleteDialog: false,
    deleteAllCheck: false,
    selectedCheckID: null,
    checksID: [],
    checksTotal: 0,
    checkAverageDate: null,
    invoice_without_due_date: null,
    isThereInvoiceWithoutId: false,
    taxPayerSelectedItems: null,
    taxPayerConfirmDialog: false,
    invoiceErrorDialog: false,
    invoiceErrorHeaders: null,
    invoiceErrorItems: null,
    invoiceErrorDetailsDialog: false,
    selectedInvoiceItem: null,
    selectedInvoiceErrors: null,
    invoiceErrorDetailsHeaders: null,
    taxPayerStatusReviewDialog: false,
    taxPayerStatusError: null,
    taxPayerStatusErrorItems: null,
    taxPayerStatusErrorHeaders: null,
    alertDialog: false,
    alertDialogText: null,
    successAlert: false,
    isUserHasTaxPayer: false,
    removeType: null,
    products: null,
    payedStatus: null,
    fromTime: null,
    toTime: null,
    payedDialog: false,
    selectedPayedItem: null,
    listViewportObserver: null,
    listViewportRaf: null,
  }),
  computed: {
    isDesktopListLayout() {
      // Embedded usages (typeProp/mobileShow) keep the desktop view as before
      if (this.typeProp || this.mobileShow) return true;
      return this.$vuetify.breakpoint.width >= 800;
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    isDesktopListViewport() {
      // Keep full-height dense layout on tablet too; only real mobile /
      // embedded list modes drop out (avoids the short 323px table).
      return !this.isMobile && !this.mobileShow && !this.typeProp;
    },
    proListKey() {
      return this.invoiceListColumnPersistKey;
    },
    proListLocked() {
      return this.invoiceListLockedColumns;
    },
    invoiceCanCreate() {
      return (
        this.$route.name !== "sellTaxPayer" &&
        this.$store.state.permissions &&
        this.$store.state.permissions.includes(this.type)
      );
    },
    invoiceListColumnPersistKey() {
      return "invoice-list-table-columns-v4-" + (this.type || "sell");
    },
    visibleTagCount() {
      var tagsHeader = (this.headers || []).find(function (header) {
        return header && header.value === "tags";
      });
      var width = Number(tagsHeader && tagsHeader.width) || 180;
      // Reserve ~38px for the "+N" trigger and cell padding; each tag
      // chip takes an 86px slot (max-width) plus the 4px flex gap.
      return Math.max(1, Math.floor((width - 38) / 90));
    },
    invoiceListLockedColumns() {
      // Fixed sticky block: select + # + id + doc number + customer (no unpin/drag)
      var locked = ["action", "id", "doc_header.number", "customer.name"];
      return this.showSelect ? ["__select"].concat(locked) : locked;
    },
    invoiceListColumnPlugins() {
      // show-select inserts a leading checkbox <th>; pad visibleHeaders so
      // pin/resize/drag index mapping stays aligned with thead cells.
      var selectHeader = {
        value: "__select",
        text: "",
        width: 32,
        sortable: false,
        pinned: false,
        originalIndex: -1,
      };
      var visible = this.showSelect
        ? [selectHeader].concat(this.tableHeaders || [])
        : this.tableHeaders || [];
      return {
        headers: this.headers,
        visibleHeaders: visible,
        locked: this.invoiceListLockedColumns,
        anchor: "customer.name",
        minWidth: 60,
        persistKey: this.invoiceListColumnPersistKey,
      };
    },
    showHeaders() {
      var app = this;
      // keep same object refs so pin/resize state stays on headers
      return this.headers.filter(function (s) {
        if (app.type !== "sell" && app.type !== "returnSell") {
          if (s.value === "pre_invoice") {
          } else {
            if (s.align != "d-none") {
              return app.selectedHeaders.includes(s);
            }
          }
        } else {
          if (s.align != "d-none") {
            return app.selectedHeaders.includes(s);
          }
        }
      });
    },
    totals: function () {
      // var total = this.items.map(function (value, key) {
      //   app.remove(value, key)
      // })
      // var app = this
      // app.excelItems = []
      const totals = this.items.reduce(
        (acc, d) => {
          acc.price += d.price
            ? parseFloat(d.price.price) +
              parseFloat(d.discount ? d.discount : 0) -
              parseFloat(d.tax ? d.tax : 0)
            : 0;
          acc.sumNetAmount += d.price ? parseFloat(d.price.price) : 0;
          acc.discount += parseFloat(d.discount);
          acc.tax += parseFloat(d.tax);
          acc.credit += parseFloat(d.credit || 0);
          return acc;
        },
        {
          sumNetAmount: 0,
          price: 0,
          discount: 0,
          tax: 0,
          credit: 0,
        }
      );
      return totals;
    },
    payedStatuses() {
      return [
        { label: this.$t("payed"), value: "payed" },
        { label: this.$t("not-payed"), value: "notPayed" },
      ];
    },
    activeFilterChips() {
      var app = this;
      var has = function (v) {
        if (Array.isArray(v)) return v.length > 0;
        return v !== null && v !== undefined && v !== "" && v !== "0" && v !== 0;
      };
      var show = function (v) {
        if (Array.isArray(v)) return v.length > 1 ? String(v.length) : show(v[0]);
        if (v && typeof v === "object") return v.name || v.text || v.label || "";
        return typeof v === "number" || typeof v === "string" ? String(v) : "";
      };
      var pick = function (items, v, key) {
        var arr = Array.isArray(v) ? v : [v];
        return arr
          .map(function (x) {
            var f = (items || []).find(function (i) {
              return i.value === x;
            });
            return f ? f[key || "text"] : "";
          })
          .filter(Boolean)
          .join("، ");
      };
      var defs = [
        ["account", app.$t("customer")],
        ["sellStatus", app.$t("status")],
        ["currencyFilter", app.$t("currency")],
        ["tag", app.$t("tag")],
        ["category", app.$t("category")],
        [
          "payedStatus",
          app.$t("payed-status"),
          pick(app.payedStatuses, app.payedStatus, "label"),
        ],
        ["fromDate", app.$t("from") + " " + app.$t("date")],
        ["toDate", app.$t("until") + " " + app.$t("date")],
        ["fromTime", app.$t("from-hour")],
        ["toTime", app.$t("to-hour")],
        ["fromDueDate", app.$t("fromDueDate")],
        ["toDueDate", app.$t("toDueDate")],
        ["fromNumber", app.$t("from") + " " + app.$t("number")],
        ["toNumber", app.$t("until") + " " + app.$t("number")],
        ["fromAmount", app.$t("from") + " " + app.$t("amount")],
        ["toAmount", app.$t("until") + " " + app.$t("amount")],
        ["branch", app.$t("branch")],
        ["entrepot", app.$t("entrepot")],
        ["registerar", app.$t("registerar")],
        [
          "lockStatus",
          app.$t("lockStatusDocuments"),
          pick(app.lockStatusItems, app.lockStatus),
        ],
        ["customFields", app.$t("sellFilterCustom")],
      ];
      return defs
        .filter(function (d) {
          return has(app[d[0]]);
        })
        .map(function (d) {
          return {
            key: d[0],
            label: d[1],
            value: d.length > 2 ? d[2] : show(app[d[0]]),
          };
        });
    },
  },
  watch: {
    selectedHeaders(val) {},
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      // taxPayerSystem
      this.taxPayerSelectedItems = this.selected.filter((item) => {
        const created = moment(item.date, "jYYYY/jMM/jDD");
        const now = moment();

        // special windows
        const esfStart = moment("1404/12/01", "jYYYY/jMM/jDD");
        const esfEnd = moment("1404/12/29", "jYYYY/jMM/jDD");
        const esfDeadline = moment("1405/01/31", "jYYYY/jMM/jDD");
        //change this for ordibehesht
        const farStart = moment("1405/01/01", "jYYYY/jMM/jDD");
        const farEnd = moment("1405/02/15", "jYYYY/jMM/jDD");
        const farDeadline = moment("1405/02/30", "jYYYY/jMM/jDD");

        // 1) esf window check
        if (created.isBetween(esfStart, esfEnd, undefined, "[]")) {
          return now.isSameOrBefore(esfDeadline, "day");
        }

        // 2) far window check
        if (created.isBetween(farStart, farEnd, undefined, "[]")) {
          return now.isSameOrBefore(farDeadline, "day");
        }

        // 3) normal 30‑day rule
        return now.diff(created, "days") <= 15;
      });

      // get Average
      const validItems = this.selected.filter((item) => item.due_date != null);
      this.selectedCheck = validItems;
      this.invoice_without_due_date = this.selected.filter(
        (item) => item.due_date == null
      );

      this.$emit("input", this.selected.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0].text;
        this.temp = this.selected[0].text;
      }
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      app.page = 1;
      app.getItems();
    },
    options: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.options?.sortBy?.map(function (value, key) {
          const index = app.headers.findIndex((h) => h.value === value);
          app.sortBy.push(app.headers[index].table);
        });
        this.getItems();
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers?.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
    accountProp(val) {
      this.getItems();
    },
    checkAverageDialog(val) {
      if (val) {
        this.selectedDate = this.today;
        this.checkAverageItems = this.selectedCheck;
      }
    },
    checkAverageItems(val) {
      this.selected = val;
      this.resolveChecksTotal();
    },
    summary() {
      if (this.isDesktopListViewport) {
        this.scheduleDesktopTableHeightUpdate();
      }
    },
    loading(val) {
      if (!val && this.isDesktopListViewport) {
        this.scheduleDesktopTableHeightUpdate();
      }
    },
    isDesktopListViewport(val) {
      if (val) {
        this.$nextTick(() => {
          this.updateDesktopTableHeight();
          this.bindListViewportObserver();
        });
      } else {
        this.unbindListViewportObserver();
        this.tableHeight = window.innerHeight - 245;
      }
    },
  },
  activated() {
    // this.getItems()
    if (this.isDesktopListViewport) {
      this.$nextTick(() => {
        this.bindListViewportObserver();
        this.scheduleDesktopTableHeightUpdate();
      });
    }
  },
  deactivated() {
    this.unbindListViewportObserver();
  },
  beforeMount() {
    this.isUserHasTaxPayer = JSON.parse(localStorage.getItem("hasTaxPayer"));

    if (this.$route.name === "purchaseList") {
      this.type = "purchase";
    }
    if (this.$route.name === "presaleList") {
      this.type = "presale";
    }
    if (this.$route.name === "sellList") {
      this.type = "sell";
    }
    if (this.$route.name === "returnPurchaseList") {
      this.type = "returnPurchase";
    }
    if (this.$route.name === "returnSellList") {
      this.type = "returnSell";
    }
    if (this.$route.name === "sellTaxPayer") {
      this.type = "sell";
    }
    if (this.$route.name === "removedInvoices") {
      this.type = "removedInvoices";
      this.removedInvoices = "active";
    }
    if (this.typeProp) {
      this.type = this.typeProp;
    }

    this.printHeaders = [
      {
        text: this.$t("id"),
        value: "id",
      },
      {
        text: this.$t("number"),
        value: "number",
      },
      {
        text: this.$t("detailsName"),
        value: "customer.name",
      },
      {
        text: this.$t("mobile"),
        value: "customer.mobile",
      },
      {
        text: this.$t("date"),
        value: "date",
      },
      {
        text: this.$t("NetAmount"),
        value: "price.NetPrice",
        sum: true,
      },
      {
        text: this.$t("discount"),
        value: "discount",
        sum: true,
        type: "number",
      },
      {
        text: this.$t("tax"),
        value: "tax",
        sum: true,
        type: "number",
      },
      {
        text: this.$t("club-credit"),
        value: "credit",
        sum: true,
        type: "number",
        align: this.hasCustomerClub ? "center" : "d-none",
      },
      {
        text: this.$t("finalAmount"),
        value: "price.price",
        sum: true,
        type: "number",
      },
      {
        text: this.$t("sumPayments"),
        value: "payed.paymentsAmount",
        sum: true,
        type: "number",
      },
      {
        text: this.$t("sumChecks"),
        value: "payed.checksAmount",
        sum: true,
        type: "number",
      },
      {
        text: this.$t("sumPayed"),
        value: "payed.amount",
        sum: true,
        type: "number",
      },
    ];
    if (!this.hasCustomerClub) {
      this.printHeaders = this.printHeaders.filter((h) => h.value !== "credit");
    }
    this.productStatusItems = [
      {
        value: "active",
        text: this.$t("active"),
      },
      {
        value: "deactive",
        text: this.$t("deactive"),
      },
    ];
    if (this.input) {
      this.model = this.input;
    }
    this.checkAverageHeaders = [
      {
        text: this.$t("#"),
        align: "start",
        sortable: false,
        value: "row",
        width: 25,
      },
      {
        text: this.$t("invoic-number"),
        align: "start",
        sortable: false,
        value: "checkNumber",
      },
      {
        text: this.$t("detailsInvoice"),
        align: "start",
        sortable: false,
        value: "detailsInvoice",
      },
      {
        text: this.$t("dueDate"),
        align: "start",
        sortable: false,
        value: "dueDate",
      },
      {
        text: this.$t("amount"),
        align: "start",
        sortable: false,
        value: "amount",
      },
      {
        text: this.$t("edit"),
        align: "start",
        sortable: false,
        value: "edit",
      },
    ];
    this.invoiceErrorHeaders = [
      {
        text: this.$t("#"),
        align: "start",
        sortable: false,
        value: "row",
        width: 20,
      },
      {
        text: this.$t("invoic-number"),
        align: "start",
        sortable: false,
        value: "invoiceNumber",
      },
      {
        text: this.$t("amount"),
        align: "start",
        sortable: false,
        value: "amount",
      },
      {
        text: this.$t("detailsInvoice"),
        align: "start",
        sortable: false,
        value: "detailsInvoice",
      },
      {
        text: this.$t("register-date"),
        align: "start",
        sortable: false,
        value: "registerDate",
      },
      {
        text: this.$t("action"),
        align: "start",
        sortable: false,
        value: "action",
      },
    ];
    this.invoiceErrorDetailsHeaders = [
      {
        text: this.$t("#"),
        align: "start",
        sortable: false,
        value: "row",
        width: 20,
      },
      {
        text: this.$t("system-errors"),
        align: "start",
        sortable: false,
        value: "systemErrors",
      },
      {
        text: this.$t("action"),
        align: "start",
        sortable: false,
        value: "action",
      },
    ];
    this.taxPayerStatusErrorHeaders = [
      {
        text: this.$t("#"),
        align: "start",
        sortable: false,
        value: "row",
        width: 20,
      },
      {
        text: this.$t("system-errors"),
        align: "start",
        sortable: false,
        value: "systemErrors",
      },
    ];
  },
  mounted() {
    this.setToday();
    this.getPermissions();

    this.headers = [
      {
        text: this.$t("#"),
        align: "center",
        sortable: false,
        value: "action",
        width: 42,
        class: "invoice-list-action-col",
        cellClass: "invoice-list-action-col",
      },
      {
        text: this.$t("id"),
        align: "start",
        sortable: true,
        value: "id",
        table: "invoice_header.id",
        width: 64,
      },
      {
        text: this.$t("number") + " " + this.$t("document"),
        align: "start",
        sortable: false,
        value: "doc_header.number",
        width: 60,
      },
      {
        text: this.$t("detailsName"),
        sortable: false,
        value: "customer.name",
        width: 120,
      },
      {
        text: this.$t("date"),
        align: "center",
        sortable: true,
        value: "date",
        table: "invoice_header.date",
        width: 64,
      },
      {
        text: this.$t("discount"),
        align: "center",
        sortable: false,
        value: "discount",
        width: 72,
      },
      {
        text: this.$t("tax"),
        align: "center",
        sortable: false,
        value: "tax",
        width: 72,
      },
      {
        text: this.$t("finalAmount"),
        align: "center",
        sortable: false,
        value: "price.price",
        width: 88,
      },
      {
        text: this.$t("sumPayed"),
        sortable: false,
        value: "payed.amount",
        width: 88,
      },
      {
        text: this.$t("preInvoice"),
        sortable: false,
        value: "pre_invoice",
        table: "doc_header.pre_invoice",
        width: 44,
      },
      {
        text: this.$t("entrepot"),
        sortable: false,
        value: "entrepot.id",
        width: 64,
      },
      {
        text: this.$t("branch"),
        align: "center",
        sortable: false,
        value: "branch.name",
        width: 80,
      },
      {
        text: this.$t("status"),
        sortable: false,
        value: "last_status.status_id",
        table: "doc_header.buyer_id",
        width: 72,
      },
      {
        text: this.$t("dueDate"),
        align: "center",
        sortable: false,
        value: "due_date",
        width: 90,
      },
      {
        text: this.$t("tag"),
        sortable: false,
        value: "tags",
        width: 180,
        minWidth: 150,
      },
      {
        text: this.$t("taxId"),
        sortable: false,
        value: "taxid",
        width: 110,
        align:
          this.isUserHasTaxPayer && (this.type == "sell" || this.type == "returnSell")
            ? "center"
            : "d-none",
      },
      {
        text: this.$t("system-status"),
        sortable: false,
        value: "system_status",
        width: 110,
        align:
          this.isUserHasTaxPayer && (this.type == "sell" || this.type == "returnSell")
            ? "center"
            : "d-none",
      },
      {
        text: this.$t("other"),
        sortable: false,
        value: "content",
        table: "products.description",
        width: 140,
      },
      {
        text: this.$t("registerar"),
        align: "center",
        sortable: false,
        value: "user.name",
        width: 80,
      },
    ];

    this.selectedHeaders = this.headers;
    reorderPinnedHeaders(this.headers, {
      locked: this.invoiceListLockedColumns,
      anchor: "customer.name",
    });
    this.loadInvoiceListColumnSettings();
    if (this.isDesktopListViewport) {
      this.$nextTick(() => {
        this.bindListViewportObserver();
        this.updateDesktopTableHeight();
        // Footer + page-totals render after table mount; remeasure once more.
        this.$nextTick(() => {
          this.bindListViewportObserver();
          this.scheduleDesktopTableHeightUpdate();
        });
      });
    }
  },
  beforeDestroy() {
    this.unbindListViewportObserver();
    if (this.listViewportRaf) {
      cancelAnimationFrame(this.listViewportRaf);
      this.listViewportRaf = null;
    }
  },
  methods: {
    loadInvoiceListColumnSettings() {
      var app = this;
      if (!app.headers || !app.headers.length) return;
      loadColumnSettings(app, app.invoiceListColumnPersistKey).then(function (snapshot) {
        if (!snapshot || !snapshot.length) return;
        applyColumnSettings(app.headers, snapshot, {
          locked: app.invoiceListLockedColumns,
          anchor: "customer.name",
        });
        // Widths saved before the tags column got a larger minimum
        // would otherwise keep it narrower than the new minWidth.
        var tagsHeader = app.headers.find(function (header) {
          return header && header.value === "tags";
        });
        if (tagsHeader && Number(tagsHeader.width) < 150) {
          tagsHeader.width = 150;
        }
        app.$forceUpdate();
      });
    },
    resolveRefEl(ref) {
      if (!ref) return null;
      return ref.$el || ref;
    },
    onResize() {
      if (this.isDesktopListViewport) {
        this.updateDesktopTableHeight();
        return;
      }
      this.tableHeight = window.innerHeight - 245;
    },
    scheduleDesktopTableHeightUpdate() {
      if (this.listViewportRaf) {
        cancelAnimationFrame(this.listViewportRaf);
      }
      this.listViewportRaf = requestAnimationFrame(() => {
        this.listViewportRaf = null;
        this.updateDesktopTableHeight();
      });
    },
    updateDesktopTableHeight() {
      if (!this.isDesktopListViewport) {
        this.tableHeight = window.innerHeight - 245;
        return;
      }

      const rootEl = this.resolveRefEl(this.$refs.listRoot);
      if (!rootEl) {
        this.tableHeight = Math.max(180, window.innerHeight - 245);
        return;
      }

      const toolbarEl = this.resolveRefEl(this.$refs.listToolbar);
      const summaryEl = this.resolveRefEl(this.$refs.listSummary);
      const tableColEl = this.resolveRefEl(this.$refs.listTableCol);
      const tableEl = this.resolveRefEl(this.$refs.listTable);
      const footerEl = tableEl ? tableEl.querySelector(".v-data-footer") : null;

      const toolbarH = toolbarEl ? toolbarEl.offsetHeight : 0;
      const summaryH = summaryEl ? summaryEl.offsetHeight : 0;
      const footerH = footerEl ? footerEl.offsetHeight : 56;
      const rootStyle = window.getComputedStyle(rootEl);
      const rootYPad =
        (parseFloat(rootStyle.paddingTop) || 0) +
        (parseFloat(rootStyle.paddingBottom) || 0);
      const tableColStyle = tableColEl ? window.getComputedStyle(tableColEl) : null;
      const tableColYPad = tableColStyle
        ? (parseFloat(tableColStyle.paddingTop) || 0) +
          (parseFloat(tableColStyle.paddingBottom) || 0)
        : 0;

      // Prefer measuring the flex table column; fall back to root chrome subtraction.
      // Footer height already includes the fixed page-totals bar (footer.prepend).
      // Root padding-bottom keeps a gap between footer and sheet edge.
      let available = 0;
      if (tableColEl && tableColEl.clientHeight > footerH) {
        available = tableColEl.clientHeight - footerH;
      } else {
        available =
          rootEl.clientHeight -
          rootYPad -
          toolbarH -
          summaryH -
          footerH -
          tableColYPad;
      }

      this.tableHeight = Math.max(180, Math.floor(available));
    },
    bindListViewportObserver() {
      if (typeof ResizeObserver === "undefined") return;
      this.unbindListViewportObserver();
      const rootEl = this.resolveRefEl(this.$refs.listRoot);
      const summaryEl = this.resolveRefEl(this.$refs.listSummary);
      const tableColEl = this.resolveRefEl(this.$refs.listTableCol);
      const tableEl = this.resolveRefEl(this.$refs.listTable);
      const footerEl = tableEl ? tableEl.querySelector(".v-data-footer") : null;
      const pageTotalsEl = this.resolveRefEl(this.$refs.listPageTotals);
      if (!rootEl && !summaryEl && !tableColEl) return;

      this.listViewportObserver = new ResizeObserver(() => {
        this.scheduleDesktopTableHeightUpdate();
      });
      if (rootEl) this.listViewportObserver.observe(rootEl);
      if (summaryEl) this.listViewportObserver.observe(summaryEl);
      if (tableColEl) this.listViewportObserver.observe(tableColEl);
      if (footerEl) this.listViewportObserver.observe(footerEl);
      if (pageTotalsEl) this.listViewportObserver.observe(pageTotalsEl);
    },
    unbindListViewportObserver() {
      if (this.listViewportObserver) {
        this.listViewportObserver.disconnect();
        this.listViewportObserver = null;
      }
    },
    openPayedDetailsDialog(item) {
      this.selectedPayedItem = item;
      this.payedDialog = true;
    },
    invoiceListPayedRemain(item) {
      if (!item || !item.payed || !item.price) return 0;
      return (
        parseFloat(item.price.price) -
        parseFloat(item.payed.amount || 0) -
        parseFloat(item.credit || 0)
      );
    },
    invoiceListPayedIsRemain(item) {
      return this.invoiceListPayedRemain(item) > 0;
    },
    invoiceListHasOtherContent(item) {
      if (!item) return false;
      var keys = [
        "woocommerceInvoice",
        "digikalaInvoice",
        "sazitoInvoice",
        "webziInvoice",
        "portalInvoice",
        "basalamInvoice",
        "mixinInvoice",
        "magnetInvoice",
        "snapshopInvoice",
        "markitoInvoice",
      ];
      var hasIntegrator =
        item.integrator &&
        item.integrator.some(function (row) {
          return row && row.value && keys.indexOf(row.key) !== -1;
        });
      var hasFields = item.custom_fields && item.custom_fields.length > 0;
      return !!(hasIntegrator || hasFields || item.content);
    },
    invoiceListOtherSummary(item) {
      if (!item) return this.$t("haveNot");
      var parts = [];
      if (item.integrator && item.integrator.length) {
        var count = item.integrator.filter(function (row) {
          return row && row.value;
        }).length;
        if (count) parts.push(count + " " + this.$t("id"));
      }
      if (item.custom_fields && item.custom_fields.length) {
        parts.push(item.custom_fields.length + " " + this.$t("details"));
      }
      if (item.content) {
        var text = String(item.content);
        parts.push(text.length > 18 ? text.substr(0, 18) + "…" : text);
      }
      return parts.length ? parts.join(" · ") : this.$t("details");
    },
    invoiceListOtherDetailRows(item) {
      if (!item || !item.integrator) return [];
      var app = this;
      var iconMap = {
        woocommerceInvoice: require("@/assets/woo.png"),
        digikalaInvoice: require("@/assets/digikala.png"),
        basalamInvoice: require("@/assets/basalam.png"),
        sazitoInvoice: require("@/assets/sazito(1).png"),
        magnetInvoice: require("@/assets/integrators/logo-magnet.png"),
        mixinInvoice: require("@/assets/integrators/mixin.png"),
        snapshopInvoice: require("@/assets/integrators/snapShop.png"),
        webziInvoice: require("@/assets/webzi.png"),
        markitoInvoice: require("@/assets/markito.png"),
        portalInvoice: require("@/assets/portal.png"),
      };
      var channelMap = {
        woocommerceInvoice: "woocommerce",
        digikalaInvoice: "digikala",
        basalamInvoice: "basalam",
        sazitoInvoice: "sazito",
        magnetInvoice: "magnet",
        mixinInvoice: "mixin",
        snapshopInvoice: "snapshop",
        webziInvoice: "webzi",
        markitoInvoice: "markito",
        portalInvoice: "portal",
      };
      return item.integrator
        .filter(function (row) {
          return row && row.value && iconMap[row.key];
        })
        .map(function (row) {
          var panel =
            row.panel && row.panel.abr_name ? " (" + row.panel.abr_name + ")" : "";
          return {
            img: iconMap[row.key],
            label: app.$t("id") + ":" + panel,
            value: row.value,
            copy: row.value,
            channel: channelMap[row.key] || null,
          };
        });
    },
    openIntegratorChannel(row) {
      if (!row || !row.channel || !row.copy) return;
      var routeMap = {
        digikala: "integratorDigikala",
        sazito: "integratorSazito",
        portal: "integratorPortal#V3",
        magnet: "integratorMagnet",
        dobare: "integratorDobare",
        mixin: "integratorMixin",
        basalam: "integratorBasalam",
        afra: "integratorAfra",
      };
      var name = routeMap[row.channel];
      if (!name) return;
      this.$router.push({
        name: name,
        params: { id: String(row.copy) },
      });
    },
    resolveAnnulmentBtnVisibility(item) {
      if (
        (item.tax_payer != null &&
          item.tax_payer.state == "new" &&
          item.tax_payer.status == "SUCCESS") ||
        (item.tax_payer != null &&
          item.tax_payer.state == "edit" &&
          item.tax_payer.status == "SUCCESS") ||
        (item.tax_payer != null &&
          item.tax_payer.state == "edit" &&
          item.tax_payer.status == "FAILED") ||
        (item.tax_payer != null &&
          item.tax_payer.state == "delete" &&
          item.tax_payer.status == "FAILED")
      ) {
        return true;
      }
    },
    resolveDeleteBtnVisibility(item) {
      if (
        item.tax_payer == null ||
        item.tax_payer == undefined ||
        (item.tax_payer != null &&
          item.tax_payer.state == "new" &&
          item.tax_payer.status == "FAILED") ||
        (item.tax_payer != null &&
          item.tax_payer.state == "delete" &&
          item.tax_payer.status == "SUCCESS")
      ) {
        return true;
      }
    },
    setToday() {
      var m = moment();
      if (this.$store.state.date_locale === "fa,en") {
        const shamsiYear = m.jYear();
        const shamsiMonth = String(m.jMonth() + 1).padStart(2, "0");
        const shamsiDay = String(m.jDate()).padStart(2, "0");
        this.today = `${shamsiYear}/${shamsiMonth}/${shamsiDay}`;
      }
      if (this.$store.state.date_locale === "en,fa") {
        this.today = m.format("YYYY/MM/DD");
      }
    },
    creatExcelData(data, type = "page") {
      var app = this;
      if (type === "page") {
        app.excelItems = [];
      }
      data.map(function (d) {
        const tags = d.tags.map((item) => item.text).join(",");
        app.excelItems.push({
          id: d.id,
          type: app.$t(d.type),
          number: d.number,
          customer: d.customer ? d.customer.name : null,
          mobile: d.customer ? d.customer.mobile : null,
          date: d.date,
          price: app.$numberFormat(d.price ? d.price.price : 0),
          discount: app.$numberFormat(d.discount),
          tax: app.$numberFormat(d.tax),
          warehouse: d.entrepot && d.entrepot.entrepot ? d.entrepot.entrepot.name : "",
          internal_code:
            d.branch && d.branch.internal_code
              ? d.branch.internal_code
              : app.$t("haveNot"),
          financial_code:
            d.customer &&
            d.customer.financial_code &&
            d.customer.financial_code !== "null"
              ? d.customer.financial_code
              : "",
          payment: d.payed ? app.$numberFormat(d.payed.amount) : "",
          content: d.content,
          dueDate: d.due_date ? d.due_date : "",
          tags: d.tags ? tags : null,
          integrator:
            d.integrator && d.integrator.length > 0
              ? app.$t(d.integrator[0].key) +
                " = " +
                d.integrator[0].value +
                " | " +
                d.integrator[0].number
              : "",
          user: d.user ? d.user.name : "",
        });
      });
    },
    lock(item, type) {
      if (this.$store.state.userCurrentPlan != null) {
        const lockItem = this.$store.state.userCurrentPlan.plan.options.find(
          (item) => item.key == "lockSystem"
        );
        if (lockItem && lockItem.value == "deactive") {
          this.$store.commit("SET_PLAN_DIALOG", true);
          this.$router.replace("/");
        } else {
          this.selected = [item];
          this.lockGroup(type);
        }
      }
    },
    lockGroup(type) {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push(value.id);
      });
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            lock: "active",
            id: selected,
            type: type,
          },
        })
        .then((res) => {
          res = res.data;
          app.snakbarText = this.$t("opertationSuccess");
          app.snakbarColor = "green";
          app.snakbar = true;
          app.getItems();
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(function () {
          app.loading = false;
          app.selected = [];
        });
    },
    // add unlock group send type
    unlockGroup(type = "unlock") {
      this.lockGroup(type);
    },
    reviewDigikalaOrder() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push(value.id);
      });
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            reviewDigikalaOrder: "active",
            items: selected,
          },
        })
        .then((res) => {
          res = res.data;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    refreshRemovedItem() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push(value.id);
      });
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            refreshRemovedInvoices: "active",
            items: selected,
          },
        })
        .then((res) => {
          res = res.data;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    openUploadDialog(item) {
      if (this.$root) {
        this.$root.$emit("open-user-file-process", { type: "invoice" });
      }
    },
    openDocumentsDialog(item) {
      this.documentsTitleDialog =
        this.$t("documents") + " " + this.$t(item.type) + " " + item.number;
      this.documents = item.attachments;
      this.documentsDialog = true;
    },
    copyInvoice(item) {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "invoice/" + item.uid + "/edit", {
          params: {
            id: item.uid,
          },
        })
        .then((res) => {
          res = res.data;
          const meta = {
            customer: res.customer,
            branch: res.branch,
            date: res.date,
            entrepot: res.entrepot ? res.entrepot.entrepot : null,
          };
          app.$router.push({
            name: app.type,
            params: {
              itemsProp: res.article,
              metaProp: meta,
            },
          });
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    entrepot_(item) {
      this.$router.push({ name: item.type + "Edit", params: { id: item.id } });
    },
    openComponent(component, id) {
      if (this.$store.state.permissions.includes("customerEdit")) {
        this.dialogData = {
          name: component,
          id: id,
        };
        this.innerComponent = true;
      }
    },
    openDeleteDialog(item, type) {
      this.deleteItem = item;
      this.deletDialog = true;
      this.removeType = type;
    },
    openTaskDialog(item) {
      this.refId = item.rel_id;
      this.taskId = item.id;
      this.taskDialog = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      if (item.lock) {
        return false;
      }
      if (!this.removedInvoices) {
        if (item.tax_payer && item.tax_payer.state) {
          if (
            (item.tax_payer.state == "new" && item.tax_payer.status == "PENDING") ||
            (item.tax_payer.state == "edit" && item.tax_payer.status == "PENDING") ||
            (item.tax_payer.state == "delete" && item.tax_payer.status == "PENDING")
          ) {
            // show a dialog
            this.alertDialog = true;
            this.alertDialogText =
              this.$t("your invoice is pending to") +
              (item.tax_payer.state == "new"
                ? this.$t("is-sending")
                : item.tax_payer.state == "edit"
                ? this.$t("is-editing")
                : item.tax_payer.state == "delete"
                ? this.$t("is-deleting")
                : "");
            this.successAlert = false;
          } else {
            this.$router.push({
              name: this.type + "Edit",
              params: { id: item.uid, tabName: item.number },
            });
          }
        } else {
          this.$router.push({
            name: this.type + "Edit",
            params: { id: item.uid, tabName: item.number },
          });
        }
      }
    },
    editCategory(item) {
      if (!this.removedInvoices) {
        this.$router.push({
          name: "invoiceCasherEdit",
          params: { id: item.uid, tabName: item.number },
        });
      }
    },
    print(item) {
      if (!this.removedInvoices) {
        this.$router.push({
          name: "invoicePrint",
          params: { id: item.uid, tabName: item.number },
        });
      }
      // this.printId = item.uid
      // this.invoicePrintDialog = true
    },
    // Row print: one entry → choice dialog (with seller / without seller /
    // receipt printer) → print module. viewInvoice = view-only dialog.
    printChoice(item) {
      if (!this.removedInvoices) this.$refs.invoiceDocView.open(item, "print");
    },
    // Group print: selected invoices in list order → choice dialog → print module.
    groupPrintInvoices() {
      if (this.removedInvoices || !this.selected.length) return;
      var order = this.items || [];
      var pos = function (x) {
        var i = order.findIndex(function (r) { return r.uid === x.uid; });
        return i < 0 ? Number.MAX_SAFE_INTEGER : i;
      };
      var list = this.selected.slice().sort(function (a, b) { return pos(a) - pos(b); });
      this.$refs.invoiceDocView.openBatch(list);
    },
    viewInvoice(item) {
      if (!this.removedInvoices) this.$refs.invoiceDocView.open(item, "view");
    },
    fishPrint(item) {
      if (!this.removedInvoices) {
        this.$router.push({
          name: "invoiceRollprint",
          params: { id: item.uid, tabName: item.number },
        });
      }
    },
    entrepotPrint(item) {
      if (!this.removedInvoices) {
        this.$router.push({
          name: item.entrepot.type + "Print",
          params: { id: item.entrepot.id },
        });
      }
    },
    addInvoiceFilterCustomField() {
      var ref = this.$refs.invoiceFilterCf;
      if (ref && typeof ref.addRow === "function") ref.addRow();
    },
    resetFilters() {
      var app = this;
      [
        "account",
        "sellStatus",
        "currencyFilter",
        "tag",
        "category",
        "payedStatus",
        "fromDate",
        "toDate",
        "fromTime",
        "toTime",
        "fromDueDate",
        "toDueDate",
        "fromNumber",
        "toNumber",
        "fromAmount",
        "toAmount",
        "branch",
        "entrepot",
        "registerar",
        "lockStatus",
        "customFields",
      ].forEach(function (k) {
        app[k] = null;
      });
    },
    getItems() {
      var app = this;
      app.filter = false;
      app.loading = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.$axios
          .get(app.$endpoint + "invoice", {
            params: {
              search: app.search,
              accountProp: app.accountProp ? app.accountProp.id : null,
              account: app.account,
              fromDate: app.fromDate,
              toDate: app.toDate,
              fromDueDate: app.fromDueDate,
              toDueDate: app.toDueDate,
              fromTime: app.fromTime,
              toTime: app.toTime,
              fromAmount: app.fromAmount,
              category: app.category,
              toAmount: app.toAmount,
              fromNumber: app.fromNumber,
              toNumber: app.toNumber,
              currency: app.currencyFilter,
              entrepot: app.entrepot,
              branch: app.branch,
              page: app.allRows ? app.excelPage : app.options.page,
              refId: app.refId,
              type: app.type,
              sortBy: app.sortBy,
              customFields: app.customFields,
              status: app.sellStatus,
              options: app.options,
              tag: app.tag,
              typeForm: app.typeForm,
              registerar: app.registerar,
              lockStatus: app.lockStatus,
              removedInvoices: app.removedInvoices,
              taxpayer: app.$route.name === "sellTaxPayer" ? "active" : null,
              payedStatus: app.payedStatus,
            },
          })
          .then((res) => {
            res = res.data;
            if (!app.allRows) {
              app.items = res.data;
              app.totalItems = res.total;
              app.pageCount = res.last_page;
              app.from = res.from;
              app.summary = res.summary;
              app.creatExcelData(res.data);
              app.selected = [];
            } else {
              app.generateExcellForAllData(res.data, res.last_page);
            }
          })
          .catch((err) => {
            app.serverErrorHandeler(err);
          })
          .finally(() => (app.loading = false));
      }, 500);
    },
    invoiceSms(item) {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            invoiceSMS: "active",
            id: item.id,
          },
        })
        .then((res) => {
          res = res.data;
          app.snakbarColor = "green";
          app.snakbarText = this.$t("sent");
          app.snakbar = true;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    sendTaxInvoice(type = null) {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push(value.id);
      });
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            sendTaxInvoice: "active",
            type: type,
            items: selected,
          },
        })
        .then((res) => {
          res = res.data;
          if (!type) {
            app.snakbarColor = "green";
            app.snakbarText = this.$t("sent");
            app.snakbar = true;
          } else {
            app.getItems();
          }
          app.selected = [];
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    editTaxInvoice(item) {
      var app = this;
      app.loading = true;
      var selected = [item.id];
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            editTaxInvoice: "active",
            items: selected,
          },
        })
        .then((res) => {
          res = res.data;
          // if (!type) {
          //   app.snakbarColor = 'green'
          //   app.snakbarText = this.$t('sent')
          //   app.snakbar = true
          // } else {
          app.getItems();
          // }
          app.selected = [];
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    selectedPrint(item) {
      this.selected = [item];
      this.groupPrintDialog = true;
    },
    groupPrintInvoice() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push(value.id);
      });
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            groupPrint: "active",
            items: selected,
          },
        })
        .then((res) => {
          res = res.data;
          app.$router.push({
            name: "reportViewer",
            params: { dataProp: res, reportProp: app.printType },
          });
          app.selected = [];
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    remove() {
      var app = this;
      app.loading = true;
      if (
        app.deleteItem &&
        app.deleteItem.tax_payer &&
        ((app.deleteItem.tax_payer.state == "new" &&
          app.deleteItem.tax_payer.status == "PENDING") ||
          (app.deleteItem.tax_payer.state == "edit" &&
            app.deleteItem.tax_payer.status == "PENDING") ||
          (app.deleteItem.tax_payer.state == "delete" &&
            app.deleteItem.tax_payer.status == "PENDING"))
      ) {
        // show a dialog
        app.snakbar = true;
        app.snakbarText =
          app.$t("your invoice is pending to") +
          (app.deleteItem.tax_payer.state == "new"
            ? app.$t("is-sending")
            : app.deleteItem.tax_payer.state == "edit"
            ? app.$t("is-editing")
            : app.deleteItem.tax_payer.state == "delete"
            ? app.$t("is-deleting")
            : "");
        app.snakbarColor = "red";
      } else {
        if (app.removeType == "delete") {
          app.$axios
            .delete(app.$apipoint + `v2/invoice/${app.deleteItem.id}`)
            .then((res) => {
              res = res.data;
              app.deletDialog = false;
              app.deleteItem = null;
              app.selected = [];
              app.getItems();
            })
            .catch((err) => {
              app.deletDialog = false;
              app.serverErrorHandeler(err);
            })
            .finally(function () {
              app.deleteItem = null;
              app.selected = [];
              app.loading = false;
            });
        }
        if (this.removeType == "annulment") {
          app.$axios
            .delete(app.$apipoint + `v2/revoke-invoice/${app.deleteItem.id}`)
            .then((res) => {
              res = res.data;
              app.deletDialog = false;
              app.deleteItem = null;
              app.selected = [];
              app.getItems();
            })
            .catch((err) => {
              app.deletDialog = false;
              app.serverErrorHandeler(err);
            })
            .finally(function () {
              app.deleteItem = null;
              app.selected = [];
              app.loading = false;
            });
        }
      }
    },
    removegroup() {
      var app = this;
      app.loading = true;
      var selected = [];

      if (app.removeType == "delete") {
        app.selected.map(function (value, key) {
          if (app.resolveDeleteBtnVisibility(value)) {
            selected.push(value.id);
          }
        });

        app.$axios
          .delete(app.$apipoint + "v2/group-destroy", {
            params: {
              id: selected,
            },
          })
          .then((res) => {
            res = res.data;
            app.deletDialog = false;
            app.deleteItem = null;
            app.selected = [];
            app.getItems();
          })
          .catch((err) => {
            app.deletDialog = false;
            app.deleteItem = null;
            app.serverErrorHandeler(err);
          })
          .finally(function () {
            app.selected = [];
            app.loading = false;
          });
      }

      if (app.removeType == "annulment") {
        app.selected.map(function (value, key) {
          if (app.resolveAnnulmentBtnVisibility(value)) {
            selected.push(value.id);
          }
        });

        app.$axios
          .get(app.$apipoint + "v2/group-revoke-invoice", {
            params: {
              id: selected,
            },
          })
          .then((res) => {
            res = res.data;
            app.deletDialog = false;
            app.deleteItem = null;
            app.selected = [];
            app.getItems();
          })
          .catch((err) => {
            app.deletDialog = false;
            app.serverErrorHandeler(err);
          })
          .finally(function () {
            app.deleteItem = null;
            app.selected = [];
            app.loading = false;
          });
      }
    },
    getPermissions() {
      var app = this;
      app.$axios
        .get(app.$endpoint + "getdetail", {
          params: {
            select: "getPermissions",
          },
        })
        .then((res) => {
          res = res.data;
          app.$store.commit("SET_PERMISSIONS", res.permissions);
        });
    },
    fetchCheckAverageFirst() {
      if (this.selectedCheck && this.selectedCheck.length == 0) {
        this.snakbarText =
          this.$t("first add some items from list") +
          "(" +
          this.$t("only invoices with due-date can be calculated") +
          ")";
        this.snakbarColor = "red";
        this.snakbar = true;
      }

      if (this.invoice_without_due_date && this.invoice_without_due_date.length > 0) {
        this.isThereInvoiceWithoutId = true;
      }

      /* if (this.invoice_without_due_date != null) {
          const invoiceID_without_due_date = this.invoice_without_due_date.map(item => item.id)

          if (invoiceID_without_due_date.length > 0) {
            this.snakbarText = `${this.$t("selected item doesn't have due date")} : ${invoiceID_without_due_date.join(', ')}`
            this.snakbarColor = 'red'
            this.snakbar = true
          }
        } */

      this.selectedCheck.forEach((item) => {
        this.checksID.push(item.id);
      });
      if (this.checksID.length > 0) {
        var app = this;
        this.loading = true;
        app.$axios
          .post(app.$endpoint + "duedateInvoice/store", {
            ids: this.checksID,
            base_date: moment(this.today, "jYYYY/jM/jD").format("YYYY-MM-DD"),
          })
          .then((r) => {
            if (r.data) {
              this.checkAverageDate = r.data.due_date;
              if (this.checkAverageDate) {
                this.checkAverageDialog = true;
              }
              this.checksID = [];
              this.loading = false;
            }
          })
          .catch((err) => {
            if (
              err.response &&
              (err.response.status == 422 || err.response.status == 403)
            ) {
              this.snakbarText = this.$t("can't change to lower plan");
              this.snakbarColor = "red";
              this.snakbar = true;
            }
            this.serverErrorHandeler(err);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    fetchCheckAverageSecond() {
      this.loading = true;
      this.checkAverageItems.forEach((item) => {
        this.checksID.push(item.id);
      });
      if (this.checksID.length > 0) {
        var app = this;
        app.$axios
          .post(app.$endpoint + "duedateInvoice/store", {
            ids: this.checksID,
            base_date: moment(this.selectedDate, "jYYYY/jM/jD").format("YYYY-MM-DD"),
          })
          .then((r) => {
            if (r.data) {
              this.checkAverageDate = r.data.due_date;
              this.checksID = [];
              this.loading = false;
            }
          })
          .catch((err) => {
            if (
              err.response &&
              (err.response.status == 422 || err.response.status == 403)
            ) {
              this.snakbarText = this.$t("can't change to lower plan");
              this.snakbarColor = "red";
              this.snakbar = true;
            }
            this.serverErrorHandeler(err);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    openCheckDeleteDialog(select, checkId) {
      this.checkDeleteDialog = true;
      if (select == "all") {
        this.deleteAllCheck = true;
      } else {
        this.deleteAllCheck = false;
        this.selectedCheckID = checkId;
      }
    },
    deleteCheck() {
      if (this.deleteAllCheck) {
        this.checkAverageItems = [];
        this.selected = [];
      } else {
        const selectedCheckIndexTable = this.checkAverageItems.findIndex(
          (item) => item.id == this.selectedCheckID
        );
        this.checkAverageItems.splice(selectedCheckIndexTable, 1);
      }
      this.checkDeleteDialog = false;
    },
    resolveChecksTotal() {
      this.checksTotal = this.checkAverageItems.reduce((sum, item) => {
        return sum + Number(item.price ? item.price.price : 0);
      }, 0);
    },
    taxPayerConfirmation() {
      if (this.taxPayerSelectedItems && this.taxPayerSelectedItems.length > 0) {
        this.taxPayerConfirmDialog = true;
      } else {
        this.snakbar = true;
        this.snakbarText = this.$t("time-is-up");
        this.snakbarColor = "red";
      }
    },
    sendToTaxPayer() {
      var app = this;
      app.loading = true;
      app.$axios
        .post(this.$apipoint + "v2/" + "tax-payer/send", {
          items: this.taxPayerSelectedItems.map((item) => item.id),
        })
        .then((r) => {
          this.invoiceErrorItems = r.data
            .filter((item) => item.hasError == true)
            .map((item) => ({
              invoice: item.invoice,
              data: item.data,
            }));

          if (this.invoiceErrorItems && this.invoiceErrorItems.length > 0) {
            this.taxPayerConfirmDialog = false;
            this.invoiceErrorDialog = true;
          } else {
            this.taxPayerConfirmDialog = false;
          }
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showErrorDetails(item) {
      this.invoiceErrorDetailsDialog = true;
      this.selectedInvoiceItem = item;
      this.selectedInvoiceErrors = item.data[0].error;
    },
    editInvoice() {
      this.$router.push({
        name: "sellEdit",
        params: {
          id: this.selectedInvoiceItem.invoice.uid,
          tabName: this.selectedInvoiceItem.invoice.uid,
        },
      });
    },
    resolveTaxPayerStatus(item) {
      if (item.state) {
        // new
        if (item.state == "new") {
          if (item.status == "PENDING") {
            return this.$t("pending-new");
          }
          if (item.status == "SUCCESS") {
            return this.$t("success-new");
          }
          if (item.status == "FAILED") {
            return this.$t("failed-new");
          }
        }
        // edit
        if (item.state == "edit") {
          if (item.status == "PENDING") {
            return this.$t("pending-edit");
          }
          if (item.status == "SUCCESS") {
            return this.$t("success-edit");
          }
          if (item.status == "FAILED") {
            return this.$t("failed-edit");
          }
        }
        // delete
        if (item.state == "delete") {
          if (item.status == "PENDING") {
            return this.$t("pending-delete");
          }
          if (item.status == "SUCCESS") {
            return this.$t("success-delete");
          }
          if (item.status == "FAILED") {
            return this.$t("failed-delete");
          }
        }
      }
    },
    resolveTaxPayerStatusColor(item) {
      if (item.state) {
        // new
        if (item.state == "new" || item.state == "edit" || item.state == "delete") {
          if (item.status == "PENDING") {
            return "primary";
          }
          if (item.status == "SUCCESS") {
            return "success";
          }
          if (item.status == "FAILED") {
            return "error";
          }
        }
      }
    },
    openTaxPayerStatus(item) {
      if (item.state) {
        if (item.state == "new" || item.state == "edit" || item.state == "delete") {
          if (item.status == "FAILED") {
            this.taxPayerStatusError = item;
            this.taxPayerStatusErrorItems = JSON.parse(item.reponse).data[0].error;
            if (this.taxPayerStatusErrorItems) {
              this.taxPayerStatusReviewDialog = true;
            }
            this.successAlert = false;
          }
          if (item.status == "PENDING") {
            this.alertDialog = true;
            this.alertDialogText =
              this.$t("your invoice is pending to") +
              (item.state == "new"
                ? this.$t("is-sending")
                : item.state == "edit"
                ? this.$t("is-editing")
                : item.state == "delete"
                ? this.$t("is-deleting")
                : "");
            this.successAlert = false;
          }
          if (item.status == "SUCCESS") {
            this.alertDialog = true;
            this.alertDialogText = this.$t("your invoice is successfuly submited");
            this.successAlert = true;
          }
        }
      }
    },
    taxPayerConfirmationVMenu(item) {
      this.selected.push(item);
      var app = this;
      setTimeout(function () {
        app.taxPayerConfirmation();
      }, 500);
    },
    resolveSubmitionDeadline(createdDate) {
      const created = moment(createdDate, "jYYYY/jMM/jDD");
      const now = moment();

      // بازه‌ی 1 تا 29 اسفند 1404
      const esfStart = moment("1404/12/01", "jYYYY/jMM/jDD");
      const esfEnd = moment("1404/12/29", "jYYYY/jMM/jDD");
      const esfDeadline = moment("1405/01/31", "jYYYY/jMM/jDD");

      // بازه‌ی 1 تا 15 فروردین 1405
      //change this section for ordibehesht
      const farStart = moment("1405/01/01", "jYYYY/jMM/jDD");
      const farEnd = moment("1405/02/15", "jYYYY/jMM/jDD");
      const farDeadline = moment("1405/02/30", "jYYYY/jMM/jDD");

      // شرط اول
      if (created.isBetween(esfStart, esfEnd, undefined, "[]")) {
        const diffDays = Math.ceil(esfDeadline.diff(now, "hours") / 24);
        return diffDays > 0
          ? this.$t("submission-deadline") + " " + diffDays + " " + this.$t("days")
          : diffDays === 0
          ? this.$t("today")
          : this.$t("finish-deadline");
        // return diffDays >= 0
        //   ? this.$t("submission-deadline") + " " + diffDays + " " + this.$t("days")
        //   : this.$t("finish-deadline");
      }

      // شرط دوم
      if (created.isBetween(farStart, farEnd, undefined, "[]")) {
        const diffDays = Math.ceil(farDeadline.diff(now, "hours") / 24);
        return diffDays > 0
          ? this.$t("submission-deadline") + " " + diffDays + " " + this.$t("days")
          : diffDays === 0
          ? this.$t("today")
          : this.$t("finish-deadline");
        // return diffDays >= 0
        //   ? this.$t("submission-deadline") + " " + diffDays + " " + this.$t("days")
        //   : this.$t("finish-deadline");
      }

      // حالت عادی
      const defaultDeadline = created.clone().add(15, "days");
      const diffDays = Math.ceil(defaultDeadline.diff(now, "hours") / 24);

      return diffDays > 0
        ? this.$t("submission-deadline") + " " + diffDays + " " + this.$t("days")
        : diffDays === 0
        ? this.$t("today")
        : this.$t("finish-deadline");
      // return diffDays >= 0
      //   ? this.$t("submission-deadline") + " " + diffDays + " " + this.$t("days")
      //   : this.$t("finish-deadline");
    },
    // resolveSubmitionDeadline(createdDate) {
    //   const created = moment(createdDate, "jYYYY/jMM/jDD")
    //   const deadline = created.clone().add(30, "days")
    //   const now = moment()

    //   const diffDays = Math.ceil(deadline.diff(now, "hours") / 24)

    //   if (diffDays > 0) {
    //     return this.$t('submission-deadline') + ' ' + diffDays + ' ' + this.$t('days')
    //   } else {
    //     return this.$t('finish-deadline')
    //   }
    // },
    fetchProducts(items) {
      var app = this;
      app.loading = true;
      app.$axios
        .get(app.$endpoint + "getdetail", {
          params: {
            select: "getProductFromInvoice",
            ids: items.map((item) => item.id),
          },
        })
        .then((r) => {
          app.loading = false;
          this.products = r.data;
          if (this.products && this.products.length > 0) {
            this.$router.push({
              name: "labelPrintSetting",
              params: { items: this.products },
            });
          }
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(function () {
          app.loading = false;
        });
    },
    barcodeSingle(item) {
      this.fetchProducts([item]);
    },
    barcode() {
      this.fetchProducts(this.selected);
    },
  },
};
</script>

<style scoped lang="scss">
/* Desktop chrome: shared pro-list kit (slot content of ProListFrame) */
@import "~@/sass/design-system/list/pro-list";

.acf-sec__head--spread {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.acf-sec__head-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.acf-sec__add {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 28px;
  padding: 0 8px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--pl-primary);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  flex: 0 0 auto;
}
.acf-sec__add:hover {
  background: var(--pl-primary-soft);
}
/* Tighter rows: less cell padding and line height only — same layout. */
.pl ::v-deep .v-data-table tbody tr td {
  height: 30px !important;
  padding-top: 1px !important;
  padding-bottom: 1px !important;
}
.pl ::v-deep .v-data-table tbody tr td .v-card__text,
.pl ::v-deep .v-data-table tbody tr td .text-caption {
  line-height: 1.2 !important;
}
.pl .invoice-list-two-line,
.pl .invoice-list-two-line__sub {
  line-height: 1.15 !important;
}

.tax-payer-count-badge {
  min-width: 20px !important;
  height: 18px !important;
  font-size: 11px !important;
  font-weight: 600;
  border-radius: 9px !important;
  justify-content: center;
}
/* Desktop list viewport: page chrome stays fixed; only table body scrolls */
.invoice-list-page--fixed {
  height: calc(100vh - 98px);
  max-height: calc(100vh - 98px);
  padding-bottom: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.invoice-list-page--fixed .invoice-list-toolbar {
  flex: 0 0 auto;
  position: relative;
  z-index: 2;
  overflow: visible !important;
  height: auto !important;
  max-height: none !important;
}
.invoice-list-page--fixed .invoice-list-toolbar ::v-deep .v-toolbar__content {
  height: 40px !important;
  max-height: none !important;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: nowrap;
  overflow: visible;
  width: 100%;
  margin-top: 3px;
  margin-bottom: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  /* match summary row left edge (RTL inline-end) */
  padding-inline-end: 0 !important;
}
.invoice-list-page--fixed .invoice-list-toolbar.v-toolbar,
.invoice-list-page--fixed .invoice-list-toolbar.v-app-bar {
  margin-bottom: 0 !important;
}
.invoice-list-toolbar__start,
.invoice-list-toolbar__actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.invoice-list-toolbar__start--dense {
  min-width: 0;
}
.invoice-list-toolbar__actions--dense {
  margin-inline-start: auto;
}
.invoice-list-page--fixed .invoice-list-toolbar__actions--dense {
  margin-top: 4px;
}
.invoice-list-page--fixed .invoice-list-toolbar ::v-deep .v-btn {
  height: 28px !important;
  min-height: 28px !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.invoice-list-page--fixed .invoice-list-toolbar ::v-deep .v-btn .v-btn__content {
  align-items: center;
}
.invoice-list-page--fixed .invoice-list-toolbar ::v-deep .v-btn .v-btn__content p {
  font-size: 11px;
  line-height: 1;
}
.invoice-list-page--fixed .invoice-list-toolbar ::v-deep .v-btn .v-icon {
  font-size: 18px !important;
}
.invoice-list-page--fixed .invoice-list-toolbar ::v-deep .float-left {
  float: none !important;
  display: inline-flex;
  align-items: center;
}
.invoice-list-page--fixed .invoice-list-toolbar__search {
  display: flex;
  align-items: flex-start;
  margin-top: 0;
}
.invoice-list-page--fixed .invoice-list-toolbar__start--dense,
.invoice-list-page--fixed .invoice-list-toolbar__actions--dense {
  align-items: flex-start;
  padding-top: 0;
}
.invoice-list-page--fixed .invoice-list-toolbar ::v-deep .invoice-list-toolbar__search .v-text-field {
  margin-top: 0;
  padding-top: 0;
  margin-bottom: 0;
}
.invoice-list-page--fixed
  .invoice-list-toolbar
  ::v-deep
  .invoice-list-toolbar__search
  .v-text-field--outlined.v-input--dense
  .v-input__slot {
  min-height: 32px !important;
  height: 32px !important;
  align-items: center !important;
}
.invoice-list-page--fixed
  .invoice-list-toolbar
  ::v-deep
  .invoice-list-toolbar__search
  .v-input__append-inner,
.invoice-list-page--fixed
  .invoice-list-toolbar
  ::v-deep
  .invoice-list-toolbar__search
  .v-input__prepend-inner {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  align-self: stretch !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 32px !important;
  max-height: 32px !important;
}
.invoice-list-page--fixed
  .invoice-list-toolbar
  ::v-deep
  .invoice-list-toolbar__search
  .v-input__icon {
  height: 32px !important;
  min-height: 32px !important;
  width: 24px !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.invoice-list-page--fixed
  .invoice-list-toolbar
  ::v-deep
  .invoice-list-toolbar__search
  .v-input__icon .v-icon {
  height: 20px !important;
  width: 20px !important;
  font-size: 20px !important;
  line-height: 1 !important;
  margin: 0 !important;
  /* optical center for mdi-magnify glyph inside 32px field */
  transform: translateY(2px);
}
.invoice-list-page--fixed
  .invoice-list-toolbar
  ::v-deep
  .invoice-list-toolbar__search
  .v-text-field--outlined
  fieldset {
  top: 0;
}
.invoice-list-page--fixed
  .invoice-list-toolbar
  ::v-deep
  .invoice-list-toolbar__search
  .v-text-field--outlined.v-input--dense
  .v-label {
  top: 6px;
}
.invoice-list-page--fixed
  .invoice-list-toolbar
  ::v-deep
  .invoice-list-toolbar__search
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  .v-label--active {
  transform: translateY(-14px) scale(0.75);
}
/* Keep title size like before (Vuetify default ~1.25rem), not dense-shrunk */
.invoice-list-page--fixed .invoice-list-toolbar ::v-deep .invoice-list-toolbar__title,
.invoice-list-page--fixed .invoice-list-toolbar ::v-deep .v-toolbar__title {
  font-size: 1.25rem !important;
  font-weight: 400;
  line-height: 1.5;
  margin-top: 2px !important;
  margin-bottom: 0 !important;
  align-self: center;
}
.invoice-list-page--fixed .invoice-list-summary,
.invoice-list-page--fixed .invoice-list-summary--fixed {
  flex: 0 0 auto;
  position: relative;
  z-index: 1;
  margin-top: 4px;
  margin-bottom: 8px;
  clear: both;
}
.invoice-list-page--fixed .invoice-summary-actions {
  flex-shrink: 0;
  margin-inline-start: auto;
}
.invoice-summary-kpis {
  display: flex;
  align-items: stretch;
  gap: 8px;
  width: 100%;
}
.invoice-summary-kpis--flush {
  margin: 0;
}
.invoice-summary-kpi {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid #e6edf3;
  border-radius: 4px;
  box-sizing: border-box;
}
.invoice-summary-kpi--gross {
  background: #f3f8ff;
  border-color: #90caf9;
}
.invoice-summary-kpi__icon {
  flex: 0 0 36px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.invoice-summary-kpi__icon--blue {
  background: #e3f2fd;
}
.invoice-summary-kpi__icon--red {
  background: #fdecea;
}
.invoice-summary-kpi__icon--green {
  background: #e8f5e9;
}
.invoice-summary-kpi__icon--orange {
  background: #fff3e0;
}
.invoice-summary-kpi__icon--sky {
  background: #e3f2fd;
}
.invoice-summary-kpi__body {
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.25;
}
.invoice-summary-kpi__label {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.45);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.invoice-summary-kpi__value {
  font-size: 14px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.82);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.invoice-summary-kpi__unit {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.4);
}
.invoice-summary-kpis--dense .invoice-summary-kpi {
  padding: 6px 10px;
  border-radius: 4px;
}
.invoice-summary-kpis--dense .invoice-summary-kpi__icon {
  flex-basis: 32px;
  width: 32px;
  height: 32px;
}
.invoice-summary-kpis--dense .invoice-summary-kpi__value {
  font-size: 13px;
}
/* Align left edge of summary actions with toolbar actions (فروش / راس فاکتور) */
.invoice-list-page--fixed .invoice-list-toolbar__actions--dense {
  margin-inline-end: 0 !important;
  padding-inline-end: 0 !important;
}
.invoice-list-page--fixed .invoice-list-toolbar__actions--dense > .v-btn:last-child {
  margin-inline-end: 0 !important;
}
.invoice-list-page--fixed .invoice-list-summary--fixed {
  /* match table col px-2 (8px) on both sides */
  padding-inline-end: 8px;
  padding-inline-start: 8px;
  box-sizing: border-box;
}
.invoice-list-page--fixed .invoice-summary-actions--dense {
  margin-inline-end: 0 !important;
  padding-inline-end: 0 !important;
}
.invoice-list-page--fixed .invoice-summary-actions--dense .invoice-summary-actions__end-btn {
  margin-inline-end: 0 !important;
  margin-inline-start: 8px !important;
}
/* Dense dataset summary chips (above table) */
.invoice-summary-chip-group--dense {
  margin: 0 !important;
  padding: 0 !important;
}
.invoice-list-page--fixed .invoice-summary-chip-group--dense {
  margin: 0 !important;
  padding: 0 !important;
  max-width: 100%;
}
.invoice-list-page--fixed .invoice-summary-chip-group--dense ::v-deep .v-slide-group__wrapper {
  margin: 0 !important;
}
.invoice-list-page--fixed .invoice-summary-chip-group--dense ::v-deep .v-slide-group__content {
  padding: 0 !important;
  align-items: center;
}
.invoice-list-page--fixed .invoice-summary-chip-group--dense ::v-deep .v-slide-group__prev,
.invoice-list-page--fixed .invoice-summary-chip-group--dense ::v-deep .v-slide-group__next {
  display: none !important;
  min-width: 0 !important;
  width: 0 !important;
}
.invoice-summary-chip-group--dense ::v-deep .v-slide-group__content {
  padding: 0 !important;
  align-items: center;
}
.invoice-summary-chip-group--dense ::v-deep .v-chip {
  height: 25px !important;
  margin: 0 !important;
  margin-inline-end: 6px !important;
  padding: 0 8px !important;
  font-size: 11px !important;
  border-radius: 3px !important;
  border-color: #d7d7d7 !important;
  background: #f7f7f8 !important;
}
.invoice-list-page--fixed .invoice-summary-chip-group--dense ::v-deep .v-chip:first-child {
  /* outer/start edge (RTL right) flush with table edge */
  margin-inline-start: 0 !important;
}
.invoice-list-page--fixed .invoice-summary-chip-group--dense ::v-deep .v-chip:last-child {
  margin-inline-end: 0 !important;
}
.invoice-summary-chip-group--dense ::v-deep .v-chip .v-chip__content {
  padding: 0;
}
.invoice-list-page--fixed .invoice-list-table-col {
  flex: 1 1 auto !important;
  flex-grow: 1 !important;
  flex-shrink: 1 !important;
  min-height: 0 !important;
  max-width: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.invoice-list-page--fixed .invoice-list-table {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.invoice-list-page--fixed ::v-deep .invoice-list-table > .v-data-table__wrapper {
  flex: 1 1 auto;
  min-height: 0;
}
.invoice-list-page--fixed ::v-deep .invoice-list-table > .v-data-footer {
  flex: 0 0 auto;
  flex-wrap: wrap;
  align-items: center;
  min-height: unset;
  height: auto;
  /* Kill default footer side padding so the totals bar can go edge-to-edge */
  padding: 0 !important;
  margin: 0;
  border-top: none;
  background: rgba(255, 255, 255, 0.42);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.5);
  font-size: 12px !important;
}
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > *:not(.invoice-list-page-totals) {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  min-height: 43px !important;
  height: 43px !important;
  display: flex !important;
  align-items: center !important;
}
.invoice-list-page--fixed ::v-deep .invoice-list-table > .v-data-footer > .v-col {
  padding-inline: 10px !important;
  max-width: none;
  display: flex !important;
  align-items: center !important;
}
.invoice-list-goto-page {
  margin-right: 12px !important;
}
/* Desktop: col stays footer-height; glass chip inside is compact */
.invoice-list-goto-page--compact {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  align-self: center !important;
  flex: 0 0 auto !important;
  width: auto !important;
  max-width: none !important;
  min-width: 0 !important;
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  transform: none;
  /* RTL end (left): next to pagination icons */
  order: 4;
  margin-inline-start: auto !important;
}
.invoice-list-goto-page__box {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  line-height: 1;
  min-height: 0;
  width: auto;
  box-sizing: border-box;
}
.invoice-list-goto-page__label {
  flex: 0 0 auto;
  font-size: 11px;
  line-height: 24px;
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.62);
}
/* Keep nested Vuetify field transparent so the box bg shows through */
.invoice-list-goto-page--compact ::v-deep .invoice-list-goto-page__field,
.invoice-list-goto-page--compact ::v-deep .invoice-list-goto-page__field.v-text-field,
.invoice-list-goto-page--compact ::v-deep .invoice-list-goto-page__field .v-input,
.invoice-list-goto-page--compact ::v-deep .invoice-list-goto-page__field .v-input__control,
.invoice-list-goto-page--compact ::v-deep .invoice-list-goto-page__field .v-input__slot {
  margin: 0 !important;
  padding: 0 !important;
  min-height: 20px !important;
  height: 20px !important;
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
}
.invoice-list-goto-page--compact ::v-deep .invoice-list-goto-page__field {
  width: 52px;
  flex: 0 0 52px;
}
.invoice-list-goto-page--compact ::v-deep .invoice-list-goto-page__field.v-text-field--solo .v-input__slot {
  margin: 0 !important;
  align-items: center !important;
}
.invoice-list-goto-page--compact ::v-deep .invoice-list-goto-page__field fieldset {
  display: none !important;
}
.invoice-list-goto-page--compact ::v-deep .invoice-list-goto-page__field input {
  font-size: 11px;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  max-height: 20px;
  line-height: 20px;
  text-align: center;
  background: transparent !important;
}
.invoice-list-goto-page--compact ::v-deep .invoice-list-goto-page__field .v-text-field__suffix {
  align-self: center !important;
  line-height: 20px !important;
  font-size: 11px;
  margin: 0 !important;
}
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > .v-data-footer__select,
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > .v-data-footer__pagination {
  height: 24px !important;
  min-height: 24px !important;
  align-self: center !important;
  padding: 0 8px !important;
  margin-inline: 4px !important;
  border-radius: 4px;
  background: rgba(120, 130, 140, 0.12) !important;
  border: none !important;
  box-shadow: none !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  font-size: 11px !important;
  line-height: 1;
  color: rgba(0, 0, 0, 0.62);
}
/* RTL right: rows-per-page + range */
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > .v-data-footer__select {
  order: 1;
}
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > .v-data-footer__pagination {
  order: 2;
  margin-inline-start: 4px !important;
}
/* RTL left: go-to-page (order 4) + nav icons */
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > .v-data-footer__icons-before {
  order: 5;
  margin-inline-start: 4px !important;
}
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > .v-data-footer__icons-after {
  order: 6;
}
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > .v-data-footer__select
  .v-select__selection,
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > .v-data-footer__select
  .v-select__selections,
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > .v-data-footer__select
  .v-label,
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > .v-data-footer__pagination {
  color: rgba(0, 0, 0, 0.62) !important;
  font-size: 11px !important;
}
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > .v-data-footer__select
  .v-input__slot::before,
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > .v-data-footer__select
  .v-input__slot::after {
  display: none !important;
  border: none !important;
}
/* Match go-to-page glass chip on pagination icon groups (footer left in RTL) */
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > .v-data-footer__icons-before,
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > .v-data-footer__icons-after {
  height: 24px !important;
  min-height: 24px !important;
  align-self: center !important;
  padding: 0 4px !important;
  margin-inline: 4px !important;
  border-radius: 4px;
  background: rgba(120, 130, 140, 0.12) !important;
  border: none !important;
  box-shadow: none !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  font-size: 12px !important;
  line-height: 1;
}
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > .v-data-footer__icons-before
  .v-btn,
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > .v-data-footer__icons-after
  .v-btn {
  width: 22px !important;
  height: 22px !important;
  margin: 0 1px !important;
  color: rgba(55, 71, 79, 0.78) !important;
}
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > .v-data-footer__icons-before
  .v-btn
  .v-icon,
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > .v-data-footer__icons-after
  .v-btn
  .v-icon {
  font-size: 16px !important;
  color: inherit !important;
}
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > .v-data-footer__select
  .v-select,
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > .v-data-footer__select
  .v-input {
  margin: 0 !important;
  padding: 0 !important;
  font-size: 11px;
}
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > .v-data-footer__select
  .v-input__control {
  min-height: 20px !important;
  height: 20px !important;
}
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > .v-data-footer__select
  .v-input__slot {
  margin-bottom: 0 !important;
  min-height: 20px !important;
  height: 20px !important;
  align-items: center !important;
  background: transparent !important;
  box-shadow: none !important;
}
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > .v-data-footer__select
  .v-select__selections {
  font-size: 11px;
  min-height: 20px !important;
  height: 20px !important;
  padding: 0 !important;
  align-items: center;
}
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > .v-data-footer__select
  .v-input__icon,
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  > .v-data-footer__select
  .v-icon {
  height: 18px !important;
  min-width: 18px !important;
  font-size: 14px !important;
  color: rgba(55, 71, 79, 0.7) !important;
}
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  .v-btn {
  width: 28px !important;
  height: 28px !important;
  margin: 0 2px !important;
  align-self: center !important;
}
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-footer
  .v-btn
  .v-icon {
  font-size: 18px !important;
}
/* Full-width page totals row above pagination controls */
.invoice-list-page-totals {
  flex: 1 0 100% !important;
  width: 100% !important;
  max-width: 100% !important;
  align-self: stretch;
  order: -1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 8px;
  box-sizing: border-box;
  padding: 5px 10px;
  margin: 0 !important;
  border-top: 1px solid rgba(120, 130, 140, 0.12);
  border-bottom: 1px solid rgba(120, 130, 140, 0.12);
  background: rgba(120, 130, 140, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  font-size: 11px;
  line-height: 1.25;
}
/* Dense table: header / cells / secondary text closer to hard-invoice */
.invoice-list-table--dense ::v-deep > .v-data-table__wrapper > table > thead > tr:not(.v-data-table__progress) > th {
  height: 28px !important;
  padding: 0 6px !important;
  font-size: 8.5pt !important;
  font-weight: 600;
  white-space: nowrap;
  background-color: #fff !important;
  border-left: 1px solid #eeeeee !important;
  box-shadow: 0 1px 0 #eeeeee !important;
}
.invoice-list-table--dense ::v-deep > .v-data-table__wrapper > table > tbody > tr > td {
  border-left: 1px solid #eeeeee !important;
  border-bottom: 1px solid #f3f3f3 !important;
}
.invoice-list-table--dense
  ::v-deep
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:last-child,
.invoice-list-table--dense
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:last-child {
  border-left: none !important;
}
/* pin / resize / drag: sticky cell chrome (parity with invoice/entrepot tables) */
.invoice-list-table.main-table ::v-deep > .v-data-table__wrapper {
  position: relative;
  z-index: 0;
  isolation: isolate;
}
.invoice-list-table.main-table ::v-deep > .v-data-table__wrapper > table {
  border-collapse: separate;
  border-spacing: 0;
}
/* Zebra rows (same as invoice registration / InvoiceTableRow) */
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(odd)
  > td {
  background-color: #f5f5f5 !important;
  background-image: none !important;
}
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(even)
  > td {
  background-color: #fff !important;
  background-image: none !important;
}
/* Sticky/pinned cells must follow the same zebra colors */
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(odd)
  > td.is-sticky,
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(odd)
  > td.column-pin-cell.is-sticky {
  background-color: #f5f5f5 !important;
  background-clip: border-box;
  box-shadow: none !important;
}
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(even)
  > td.is-sticky,
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(even)
  > td.column-pin-cell.is-sticky {
  background-color: #fff !important;
  background-clip: border-box;
  box-shadow: none !important;
}
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover
  > td,
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover
  > td.is-sticky,
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover
  > td.column-pin-cell.is-sticky {
  background-color: #eee !important;
}
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.v-data-table__selected
  > td,
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.v-data-table__selected
  > td.is-sticky,
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.v-data-table__selected
  > td.column-pin-cell.is-sticky {
  background-color: #eeeeee !important;
}
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.v-data-table__selected:hover
  > td,
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.v-data-table__selected:hover
  > td.is-sticky,
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.v-data-table__selected:hover
  > td.column-pin-cell.is-sticky {
  background-color: #e0e0e0 !important;
}
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th[data-col="action"],
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td[data-col="action"] {
  box-sizing: border-box !important;
  width: 42px !important;
  min-width: 42px !important;
  max-width: 42px !important;
  padding: 0 2px !important;
  text-align: center !important;
}
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th[data-col="__select"],
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td[data-col="__select"] {
  box-sizing: border-box !important;
  width: 32px !important;
  min-width: 32px !important;
  max-width: 32px !important;
  padding: 0 !important;
  text-align: center !important;
}
.invoice-list-table--dense
  ::v-deep
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th[data-col="__select"],
.invoice-list-table--dense
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td[data-col="__select"] {
  width: 32px !important;
  min-width: 32px !important;
  max-width: 32px !important;
  padding: 0 !important;
}
.invoice-list-table--dense
  ::v-deep
  td[data-col="__select"]
  .v-data-table__checkbox,
.invoice-list-table--dense
  ::v-deep
  th[data-col="__select"]
  .v-data-table__checkbox,
.invoice-list-table--dense ::v-deep .v-data-table-header__icon + .v-simple-checkbox,
.invoice-list-table--dense ::v-deep .v-simple-checkbox {
  margin: 0 auto !important;
}
.invoice-list-table--dense ::v-deep td[data-col="__select"] .v-input--selection-controls {
  margin: 0 !important;
  padding: 0 !important;
  justify-content: center;
}
.invoice-list-table--dense ::v-deep td[data-col="__select"] .v-input--selection-controls__input,
.invoice-list-table--dense ::v-deep th[data-col="__select"] .v-input--selection-controls__input {
  margin: 0 !important;
  width: 18px !important;
  height: 18px !important;
}
.invoice-list-table--dense ::v-deep .column-pin-btn {
  width: 16px;
  height: 16px;
  margin-inline-end: 2px;
}
.invoice-list-table--dense ::v-deep .column-pin-btn .mdi {
  font-size: 12px;
}
.invoice-list-table--dense ::v-deep .column-drag-btn {
  opacity: 0.7;
}
/* Horizontal: ⋮ + row# — common dense-table pattern */
.invoice-list-action-cell {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1px;
  width: 100%;
  min-width: 0;
  line-height: 1;
}
.invoice-list-action-cell__btn {
  width: 22px !important;
  height: 22px !important;
  margin: 0 !important;
  flex: 0 0 auto;
}
.invoice-list-action-cell__btn .v-icon {
  font-size: 16px !important;
  color: #5c6bc0 !important;
}
.invoice-list-action-cell__row {
  display: inline-block;
  font-size: 12px;
  font-weight: 700;
  line-height: 22px;
  min-width: 0.9em;
  color: rgba(0, 0, 0, 0.82);
  text-align: center;
  flex: 0 0 auto;
}
.invoice-list-table--dense ::v-deep .invoice-list-action-col {
  width: 42px !important;
  min-width: 42px !important;
  max-width: 42px !important;
  padding: 0 2px !important;
  text-align: center !important;
}
.invoice-list-table--dense.main-table.v-data-table--dense
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr,
.invoice-list-table--dense
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(odd),
.invoice-list-table--dense
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(even) {
  height: 40px !important;
  max-height: 40px !important;
}
.invoice-list-table--dense.main-table.v-data-table--dense
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td,
.invoice-list-table--dense ::v-deep > .v-data-table__wrapper > table > tbody > tr > td {
  height: 40px !important;
  max-height: 40px !important;
  min-height: 40px !important;
  padding: 2px 6px !important;
  font-size: 11px;
  vertical-align: middle !important;
  overflow: hidden;
  line-height: 1.25;
}
.invoice-list-table--dense ::v-deep .text-caption,
.invoice-list-table--dense ::v-deep .v-card__text.text-caption {
  font-size: 10px !important;
  line-height: 1.25 !important;
}
.invoice-list-table--dense ::v-deep .v-chip.v-size--small {
  height: 20px !important;
  font-size: 10px !important;
  margin: 1px 0 !important;
}
.invoice-list-table--dense ::v-deep .v-btn--icon.v-size--small,
.invoice-list-table--dense ::v-deep .v-btn--icon.v-size--default {
  width: 28px !important;
  height: 28px !important;
}
.invoice-list-table--dense ::v-deep .v-icon {
  font-size: 18px !important;
}
.invoice-list-table--dense .invoice-list-customer-link {
  padding-top: 0;
  line-height: 1.25;
}
.invoice-list-customer-link {
  padding-top: 0;
  display: inline-block;
}
/* Icon column slot on the right (RTL start), then content — keeps icons aligned */
.invoice-list-icon-cell {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0;
  width: 100%;
  min-width: 0;
}
/* Reserve icon gutter + gap only when an icon is actually rendered */
.invoice-list-icon-cell--has-icon,
.invoice-list-icon-cell:has(.invoice-list-icon-cell__icon:not(:empty)) {
  gap: 4px;
}
.invoice-list-icon-cell__icon {
  flex: 0 0 24px;
  width: 24px;
  min-width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
}
.invoice-list-icon-cell__icon:empty {
  flex: 0 0 0;
  width: 0;
  min-width: 0;
  overflow: hidden;
}
.invoice-list-icon-cell__body {
  flex: 1 1 auto;
  min-width: 0;
  text-align: start;
}
.invoice-list-icon-cell__body--row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}
.invoice-list-icon-cell__btn {
  width: 22px !important;
  height: 22px !important;
  margin: 0 !important;
}
.invoice-list-icon-cell__glyph {
  font-size: 18px !important;
}
.invoice-list-icon-cell__img {
  width: 18px;
  height: 18px;
  object-fit: contain;
  border-radius: 0;
  display: block;
}
.invoice-list-icon-cell--inline {
  align-items: center;
}
.invoice-list-mini-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1px;
  min-width: 0;
  line-height: 1.2;
}
.invoice-list-mini-cell--inline {
  flex-direction: row;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;
}
.invoice-list-mini-cell--clickable {
  cursor: pointer;
}
.invoice-list-mini-cell__primary {
  font-size: 11px;
  white-space: nowrap;
}
.invoice-list-two-line {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0;
  min-width: 0;
  max-width: 100%;
  line-height: 1.2;
}
.invoice-list-two-line__sub {
  display: block;
  font-size: 10px !important;
  line-height: 1.2 !important;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.invoice-list-doc-cell {
  display: block;
  width: 100%;
  text-align: start;
  line-height: 1.25;
}
.invoice-list-amount-cell {
  display: block;
  width: 100%;
  text-align: center;
  line-height: 1.25;
  white-space: nowrap;
}
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th[data-col="id"],
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td[data-col="id"],
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th[data-col="doc_header.number"],
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td[data-col="doc_header.number"] {
  text-align: start !important;
}
/* Nudge customer header title slightly so it reads closer to the name text */
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th[data-col="customer.name"] {
  padding-inline-start: 8px !important; /* dense 6px + 2px */
}
/* Short pinned/draggable cols: center title + values; float pin/drag */
.invoice-list-center-cell {
  display: block;
  width: 100%;
  text-align: center;
  line-height: 1.25;
}
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th[data-col="date"],
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td[data-col="date"],
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th[data-col="branch.name"],
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td[data-col="branch.name"],
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th[data-col="due_date"],
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td[data-col="due_date"],
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th[data-col="user.name"],
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td[data-col="user.name"] {
  text-align: center !important;
}
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th[data-col="date"],
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th[data-col="branch.name"],
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th[data-col="due_date"],
.invoice-list-table.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th[data-col="user.name"] {
  position: relative;
  /* Keep centered label clear of absolute drag + pin (~16+16) */
  padding-inline-start: 34px !important;
  padding-inline-end: 6px !important;
}
.invoice-list-table--dense
  ::v-deep
  th[data-col="date"]
  .column-drag-btn,
.invoice-list-table--dense
  ::v-deep
  th[data-col="date"]
  .column-pin-btn,
.invoice-list-table--dense
  ::v-deep
  th[data-col="branch.name"]
  .column-drag-btn,
.invoice-list-table--dense
  ::v-deep
  th[data-col="branch.name"]
  .column-pin-btn,
.invoice-list-table--dense
  ::v-deep
  th[data-col="due_date"]
  .column-drag-btn,
.invoice-list-table--dense
  ::v-deep
  th[data-col="due_date"]
  .column-pin-btn,
.invoice-list-table--dense
  ::v-deep
  th[data-col="user.name"]
  .column-drag-btn,
.invoice-list-table--dense
  ::v-deep
  th[data-col="user.name"]
  .column-pin-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  margin: 0 !important;
  z-index: 2;
}
.invoice-list-table--dense ::v-deep th[data-col="date"] .column-drag-btn,
.invoice-list-table--dense ::v-deep th[data-col="branch.name"] .column-drag-btn,
.invoice-list-table--dense ::v-deep th[data-col="due_date"] .column-drag-btn,
.invoice-list-table--dense ::v-deep th[data-col="user.name"] .column-drag-btn {
  inset-inline-start: 2px;
}
.invoice-list-table--dense ::v-deep th[data-col="date"] .column-pin-btn,
.invoice-list-table--dense ::v-deep th[data-col="branch.name"] .column-pin-btn,
.invoice-list-table--dense ::v-deep th[data-col="due_date"] .column-pin-btn,
.invoice-list-table--dense ::v-deep th[data-col="user.name"] .column-pin-btn {
  inset-inline-start: 18px;
}
.invoice-list-table--dense .invoice-list-id-line,
.invoice-list-table--dense .invoice-list-customer-line {
  min-width: 0;
  max-width: 100%;
}
.invoice-list-table--dense .invoice-list-customer-link {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  line-height: 1.2;
}
.invoice-list-table--dense .invoice-list-icon-cell {
  align-items: center;
  max-height: 40px;
}
.invoice-list-table--dense .invoice-list-icon-cell__glyph {
  font-size: 16px !important;
}
.invoice-list-table--dense .invoice-list-icon-cell__btn {
  width: 22px !important;
  height: 22px !important;
}
.invoice-list-details-trigger {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 10px;
  line-height: 1.2;
  color: #5c6bc0;
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none;
}
.invoice-list-details-trigger:hover {
  text-decoration: none;
}
.invoice-list-payed-status {
  display: inline-flex;
  align-items: center;
  font-size: 10px;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
}
.invoice-list-payed-status--remain {
  color: #c62828;
}
.invoice-list-payed-status--ok {
  color: #2e7d32;
}
.invoice-list-payed-status__icon {
  color: #5c6bc0 !important;
}
.invoice-list-tooltip-lines {
  font-size: 12px;
  line-height: 1.4;
}
.invoice-list-entrepot-btn {
  max-width: 100%;
  height: auto !important;
  min-height: 0 !important;
}
.invoice-list-entrepot-btn__text {
  display: inline-block;
  max-width: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
  font-size: 11px;
}
.invoice-list-status-chip {
  max-width: 100%;
}
.invoice-list-status-chip__text {
  display: inline-block;
  max-width: 88px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
.invoice-list-tags-mini {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  flex-wrap: nowrap;
  overflow: hidden;
}
.invoice-list-tags-mini .invoice-list-details-trigger {
  flex: 0 0 auto;
}
.invoice-list-tags-mini__chip {
  border-radius: 10px !important;
  flex: 1 1 0;
  min-width: 0;
}
.invoice-list-tags-mini__chip ::v-deep .v-chip__content {
  min-width: 0;
  max-width: 100%;
  justify-content: center;
}
.invoice-list-tags-mini__chip .px-1 {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
.invoice-list-other-compact {
  min-width: 0;
  max-width: 100%;
}
/* Mini logo+id / truncated text inside dense 40px row — no row growth */
.invoice-list-other-compact__body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1px;
  min-width: 0;
  max-height: 36px;
  overflow: hidden;
}
.invoice-list-other-compact__row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 3px;
  min-width: 0;
  height: 17px;
  line-height: 17px;
}
.invoice-list-other-compact__logo {
  width: 13px;
  height: 13px;
  object-fit: contain;
  flex: 0 0 13px;
  display: block;
}
.invoice-list-other-compact__label,
.invoice-list-other-compact__value {
  font-size: 10px;
  line-height: 17px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.invoice-list-other-compact__label {
  flex: 0 0 auto;
  color: rgba(0, 0, 0, 0.7);
}
.invoice-list-other-compact__value {
  flex: 1 1 auto;
  min-width: 0;
  color: rgba(0, 0, 0, 0.54);
}
.invoice-list-other-compact__content,
.invoice-list-other-compact__fields {
  display: block;
  max-width: 100%;
  font-size: 10px;
  line-height: 17px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
}
.invoice-list-other-compact__fields {
  color: #5c6bc0;
}
.invoice-list-details-panel {
  max-height: 320px;
  overflow: auto;
}
.invoice-list-other-menu {
  direction: rtl;
  contain: initial;
}
.invoice-list-other-menu .invoice-list-details-panel {
  width: 340px;
  max-width: calc(100vw - 32px);
  box-sizing: border-box;
}
.invoice-list-details-panel__content {
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  line-height: 1.8 !important;
  text-align: right;
}
.invoice-list-table--dense ::v-deep > .v-data-footer {
  min-height: 43px !important;
  font-size: 12px;
}
.invoice-list-table--dense ::v-deep > .v-data-footer .v-btn {
  width: 28px !important;
  height: 28px !important;
}
.invoice-list-page-totals__label {
  font-weight: 700;
  color: rgba(0, 0, 0, 0.78);
  margin-inline-end: 2px;
}
.invoice-list-page-totals__item {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.72);
  padding: 2px 8px;
  border-radius: 4px;
  background: rgba(120, 130, 140, 0.12);
  border: none;
  box-shadow: none;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}
.invoice-list-page-totals__key {
  color: rgba(0, 0, 0, 0.48);
}
.invoice-list-page-totals__item--final {
  background: rgba(120, 130, 140, 0.16);
  border: none;
  box-shadow: none;
}
.invoice-list-page-totals__item--final .invoice-list-page-totals__key,
.invoice-list-page-totals__item--final .invoice-list-page-totals__val {
  font-weight: 700;
  color: rgba(0, 0, 0, 0.88);
}
/* Former body.append sum-row styles must not tint last data row on desktop */
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-table__wrapper
  tbody
  tr:last-child {
  border-top: none;
  background-color: inherit;
}
.invoice-list-page--fixed
  ::v-deep
  .invoice-list-table
  > .v-data-table__wrapper
  tbody
  tr:nth-last-child(2) {
  background-color: inherit;
}
::v-deep .v-slide-group__next,
::v-deep .v-slide-group__prev {
  justify-content: inherit;
  min-width: unset;
}
::v-deep .v-slide-group__prev.v-slide-group__prev--disabled {
  display: none;
}
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(odd),
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(even) {
  /* background-color: transparent !important; */
  height: 60px;
}
.v-card__text {
  width: auto;
}
.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}

.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
::v-deep .v-input--selection-controls__input {
  margin-left: 0;
  width: auto;
}
::v-deep .v-input--selection-controls__ripple {
  width: auto;
  height: auto;
  margin: 0;
}
::v-deep .v-btn--icon.v-size--default {
  height: auto;
  width: auto;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  height: 48px;
}
@media (max-width: 863px) {
  ::v-deep .v-data-table table tbody tr,
  ::v-deep
    .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:nth-child(odd),
  ::v-deep
    .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:nth-child(even) {
    height: auto;
  }
}

::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}
::v-deep .v-data-table.checkAverage .v-data-table-header {
  background-color: #d9d9d9;
}
::v-deep .v-data-table.checkAverage {
  border: 1px solid silver;
  /*  border-bottom: 0;
   border-bottom-right-radius: 0;
   border-bottom-left-radius: 0; */
  /* height: 300px;
  overflow-y: auto; */
}
::v-deep .v-data-table.checkAverage .v-data-table__wrapper::-webkit-scrollbar {
  width: 4px;
  height: 8px;
}
::v-deep .v-data-table.checkAverage .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}
::v-deep .v-data-table.checkAverage .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
/* ::v-deep .v-data-table.checkAverage > .v-data-table__wrapper > table {
  height: 100%;
} */
::v-deep .v-data-table.checkAverage > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 8.3pt;
  border-left: 1px solid silver !important;
  padding: 0 9px;
  color: black;
  height: 40px !important;
  background-color: #eeeeee;
}
::v-deep
  .v-data-table.checkAverage
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:first-child {
  border-top-right-radius: 4px;
}
::v-deep
  .v-data-table.checkAverage
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:last-child {
  padding: 0 8px 0 4px;
  width: 30px;
  border-left: none;
  border-top-left-radius: 4px;
}
::v-deep .v-data-table.checkAverage > .v-data-table__wrapper > table > tbody {
  position: relative;
}
::v-deep .v-data-table.checkAverage > .v-data-table__wrapper > table > tbody > tr > td {
  border-left: 1px solid silver;
  padding-right: 10px;
}
::v-deep
  .v-data-table
  > .v-data-table__wrapper
  tbody
  tr:first-child:hover
  td:first-child {
  border-top-left-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:first-child:hover td:last-child {
  border-top-right-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:last-child {
  border-top: 1px solid silver;
  background-color: #f6f6f6;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:nth-last-child(2) {
  background-color: #f6f6f6;
}
::v-deep
  .v-data-table.checkAverage
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:last-child {
  width: 0;
  border-left: none;
  padding: 0 8px 0 3.6pt;
}
::v-deep .v-data-table.checkAverage.errors > .v-data-table__wrapper > table > tbody > tr {
  background-color: #fff0f3;
}
::v-deep
  .v-data-table.checkAverage.errors
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover {
  background-color: #fff0f3;
}
/* Customer desk: flush-align search + summary; keep chip colors */
.invoice-list--embedded ::v-deep .v-toolbar__content {
  padding: 0 !important;
}
.invoice-list--embedded ::v-deep .v-toolbar__content > div:first-child {
  margin-inline-start: 0 !important;
}
/* Left edge (RTL end): align فروش with راس فاکتور */
.invoice-list--embedded ::v-deep .v-toolbar__content > .v-btn:last-child {
  margin-left: 0 !important;
  margin-inline-end: 0 !important;
}
.invoice-summary-actions {
  margin-inline-end: 0;
  margin-left: 0;
  flex-shrink: 0;
}
.invoice-summary-actions ::v-deep .v-btn {
  margin-left: 0 !important;
  margin-inline-end: 0 !important;
}
.invoice-summary-offset {
  margin-top: 16px;
}
.invoice-summary-chip-group--flush {
  margin: 0 !important;
}
.invoice-summary-chip-group--flush ::v-deep .v-slide-group__content {
  padding: 0 !important;
}
.invoice-summary-chip-group--flush ::v-deep .v-chip {
  margin-inline-start: 0;
  margin-inline-end: 8px;
}
.invoice-summary-chip-group--flush ::v-deep .v-chip:last-child {
  margin-inline-end: 0;
}
.invoice-summary-chip-group--flush ::v-deep .v-chip:first-child {
  margin-inline-start: 0 !important;
}
</style>
